export const QUESTIONS = [
  {
    "id": 1,
    "question": "A privacy program defines personal information primarily as which of the following?",
    "choice_a": "Any data stored electronically",
    "choice_b": "Any confidential business information",
    "choice_c": "Only government-issued identifiers",
    "choice_d": "Information that can identify or be linked to an individual",
    "correct_answer": "D",
    "explanation": "Personal information refers to any data that identifies or can reasonably be associated with an individual, either directly or indirectly. Direct identifiers include names, email addresses, and government identifiers, while indirect identifiers may include combinations of attributes such as location, device identifiers, or demographic data. Most privacy regulations adopt broad definitions to account for modern analytics capabilities that can re-identify individuals from seemingly innocuous data. This definition forms the foundation of privacy governance because it determines what information must be protected and subject to privacy controls.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      19,
      20,
      33,
      1,
      23
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 2,
    "question": "Which privacy principle requires integrating safeguards throughout the system lifecycle?",
    "choice_a": "Transparency",
    "choice_b": "Accountability",
    "choice_c": "Data Minimization",
    "choice_d": "Privacy by Design",
    "correct_answer": "D",
    "explanation": "Privacy by Design emphasizes embedding privacy protections into systems, processes, and technologies from the earliest stages of planning through deployment and maintenance. Rather than relying on reactive controls, organizations proactively incorporate requirements such as data minimization, purpose limitation, and access controls into architecture and workflows. This approach reduces risk, improves compliance, and ensures privacy considerations are not overlooked. It also aligns with engineering practices that treat privacy as a core requirement rather than an optional or retrofitted feature.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      21,
      24,
      43,
      23,
      10
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 3,
    "question": "A privacy policy and supporting procedures are examples of which of the following?",
    "choice_a": "Risk treatments",
    "choice_b": "Privacy documentation",
    "choice_c": "Operational metrics",
    "choice_d": "Incident response controls",
    "correct_answer": "B",
    "explanation": "Privacy documentation includes formal artifacts such as policies, standards, procedures, guidelines, and playbooks that define how privacy requirements are implemented. These documents establish expectations, assign responsibilities, and provide operational direction. Policies typically define high-level principles, while procedures describe specific steps. Together, they demonstrate governance maturity and support accountability, auditability, and consistent execution of privacy practices across the organization.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      31,
      10,
      33,
      16,
      34
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 4,
    "question": "Which activity best reflects privacy operations?",
    "choice_a": "Responding to data subject access requests",
    "choice_b": "Drafting legislation",
    "choice_c": "Defining encryption algorithms",
    "choice_d": "Building network segmentation",
    "correct_answer": "A",
    "explanation": "Privacy operations focus on executing privacy program activities, including handling data subject requests (DSRs), coordinating incident response, overseeing vendors, and maintaining records. Responding to DSRs involves verifying identity, locating personal data, and delivering responses within regulatory timelines. This operational work ensures regulatory compliance and demonstrates the organization’s ability to operationalize privacy governance requirements.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      56,
      47,
      32,
      5,
      54
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 5,
    "question": "A vendor that processes personal data on behalf of an organization should be managed primarily through which of the following?",
    "choice_a": "Source code review",
    "choice_b": "Contractual privacy requirements and due diligence",
    "choice_c": "Patch management policies",
    "choice_d": "Endpoint configuration baselines",
    "correct_answer": "B",
    "explanation": "Vendor and supply chain privacy management relies heavily on contractual obligations and due diligence. Organizations must ensure that third parties agree to data protection requirements, such as confidentiality, breach notification, and data use limitations. Due diligence assessments evaluate vendor capabilities, security posture, and compliance readiness. Ongoing monitoring ensures continued adherence. These measures help maintain accountability when personal data is processed externally.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      50,
      51,
      52,
      49,
      26
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 6,
    "question": "A Privacy Impact Assessment (PIA) is primarily used to do which of the following?",
    "choice_a": "Detect malware",
    "choice_b": "Measure encryption strength",
    "choice_c": "Audit financial controls",
    "choice_d": "Identify and evaluate privacy risks of processing activities",
    "correct_answer": "D",
    "explanation": "A PIA evaluates how personal data is collected, used, stored, and shared, identifying potential risks to individuals. The assessment analyzes data flows, purposes, legal bases, and safeguards. It then recommends controls such as minimization, access restrictions, or anonymization. PIAs are typically conducted before new systems or processing activities are introduced, ensuring privacy risks are understood and mitigated early in the lifecycle.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      73,
      74,
      75,
      59,
      64
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 7,
    "question": "Which item is an example of a privacy risk response?",
    "choice_a": "Eliminating unnecessary data collection",
    "choice_b": "Creating a data inventory",
    "choice_c": "Conducting awareness training",
    "choice_d": "Drafting privacy principles",
    "correct_answer": "A",
    "explanation": "Eliminating unnecessary data collection reduces the volume of personal information processed, thereby lowering exposure and risk. Risk responses include mitigation strategies that directly reduce likelihood or impact. Data inventories and training help identify or manage risks, but do not directly reduce exposure. Minimizing collection is one of the most effective responses to privacy risks because it reduces both breach risk and potential for misuse.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      100,
      83,
      89,
      65,
      59
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 8,
    "question": "A privacy framework, such as the NIST Privacy Framework or ISO guidance, primarily supports which of the following?",
    "choice_a": "Encryption implementation",
    "choice_b": "Database normalization",
    "choice_c": "Structured compliance and governance alignment",
    "choice_d": "Log aggregation",
    "correct_answer": "C",
    "explanation": "Privacy frameworks provide structured guidance for governance, risk management, and operational privacy controls. They help organizations identify responsibilities, implement controls, and measure program effectiveness. By aligning with recognized frameworks, organizations demonstrate due diligence and consistency. Frameworks also support regulatory mapping and continuous improvement of privacy practices.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      87,
      86,
      90,
      92,
      102
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 9,
    "question": "A data flow diagram (DFD) is most useful for which of the following?",
    "choice_a": "Calculating retention periods",
    "choice_b": "Encrypting data at rest",
    "choice_c": "Mapping data movement between systems",
    "choice_d": "Monitoring user authentication",
    "correct_answer": "C",
    "explanation": "DFDs visualize how data enters, moves through, and exits systems, including processing points and transfers. This mapping helps identify where personal data resides and how it flows between components. Understanding data flows is essential for risk assessments, compliance documentation, and identifying controls such as encryption or access restrictions. DFDs are foundational artifacts in privacy engineering and governance.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      109,
      106,
      107,
      103,
      105
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 10,
    "question": "Data use limitation requires organizations to do which of the following?",
    "choice_a": "Retain data indefinitely",
    "choice_b": "Use data only for specified purposes",
    "choice_c": "Encrypt all personal data",
    "choice_d": "Transfer data to trusted vendors",
    "correct_answer": "B",
    "explanation": "Data use limitation ensures that personal data is processed only for legitimate purposes communicated at the time of collection. This principle prevents secondary uses that were not originally disclosed. It supports transparency, accountability, and regulatory compliance. Organizations enforce this through policies, system controls, and consent management mechanisms.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      117,
      103,
      109,
      111,
      107
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 11,
    "question": "Which action best supports data minimization?",
    "choice_a": "Storing raw logs permanently",
    "choice_b": "Collecting optional demographic data",
    "choice_c": "Retaining only necessary attributes for processing",
    "choice_d": "Expanding analytics datasets",
    "correct_answer": "C",
    "explanation": "Data minimization reduces risk by limiting collection and retention to only necessary information. Retaining only essential attributes reduces exposure in the event of a breach and reduces the impact of misuse. It also simplifies compliance and lowers storage costs. Minimization applies across collection, processing, and retention decisions.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      119,
      120,
      127,
      104,
      117
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 12,
    "question": "Secure destruction of personal data is intended to do which of the following?",
    "choice_a": "Improve performance",
    "choice_b": "Prevent unauthorized recovery",
    "choice_c": "Enable analytics",
    "choice_d": "Reduce network traffic",
    "correct_answer": "B",
    "explanation": "Secure destruction ensures personal data cannot be reconstructed after disposal. Methods include shredding, overwriting, degaussing, and cryptographic erasure. Proper destruction reduces residual risk and supports retention policies. Without secure destruction, discarded media may expose sensitive information.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      129,
      127,
      111,
      128,
      120
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 13,
    "question": "The secure development lifecycle (SDLC) integrates privacy by doing which of the following?",
    "choice_a": "Eliminating testing",
    "choice_b": "Removing documentation",
    "choice_c": "Avoiding change management",
    "choice_d": "Adding privacy requirements during design and development",
    "correct_answer": "D",
    "explanation": "Integrating privacy into the SDLC includes defining requirements, performing threat modeling, implementing controls, and validating privacy protections. This ensures systems are designed to protect personal data. Early integration reduces costly redesigns and strengthens compliance.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      144,
      146,
      145,
      142,
      172
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 14,
    "question": "Identity and access management supports privacy primarily by doing which of the following?",
    "choice_a": "Improving network speed",
    "choice_b": "Increasing data retention",
    "choice_c": "Limiting access to personal data",
    "choice_d": "Enhancing analytics",
    "correct_answer": "C",
    "explanation": "Identity and access management (IAM) enforces authentication and authorization controls to restrict access to personal data. Least privilege and role-based access reduce unauthorized exposure. Proper IAM also supports accountability and auditability.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      173,
      174,
      176,
      179,
      180
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 15,
    "question": "Encryption protects personal data by doing which of the following?",
    "choice_a": "Rendering data unreadable without keys",
    "choice_b": "Removing identifiers",
    "choice_c": "Reducing storage size",
    "choice_d": "Eliminating retention requirements",
    "correct_answer": "A",
    "explanation": "Encryption transforms data into unreadable ciphertext. Only authorized parties with keys can access the information. Encryption protects data at rest and in transit, reducing the impact of breaches.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      187,
      191,
      188,
      206,
      207
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 16,
    "question": "Consent tagging in privacy engineering is used to do which of the following?",
    "choice_a": "Monitor network latency",
    "choice_b": "Encrypt browser cookies",
    "choice_c": "Associate processing with user consent preferences",
    "choice_d": "Classify hardware assets",
    "correct_answer": "C",
    "explanation": "Consent tagging attaches metadata to data elements indicating permitted processing activities. Systems can enforce consent restrictions automatically. This ensures processing aligns with user choices and regulatory requirements.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      196
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 17,
    "question": "Differential privacy is an example of which of the following?",
    "choice_a": "Data retention policy",
    "choice_b": "Privacy-enhancing technology",
    "choice_c": "Incident response mechanism",
    "choice_d": "Identity federation protocol",
    "correct_answer": "B",
    "explanation": "Differential privacy adds controlled statistical noise to outputs. This allows aggregate insights while protecting individual identities. It is widely used in analytics and AI to reduce re-identification risk.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      207,
      208,
      206
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 18,
    "question": "Monitoring and logging controls support privacy by doing which of the following?",
    "choice_a": "Increasing storage costs",
    "choice_b": "Eliminating encryption",
    "choice_c": "Detecting unauthorized access to personal data",
    "choice_d": "Replacing access control",
    "correct_answer": "C",
    "explanation": "Logs provide evidence of system activity. They help detect misuse, support investigations, and demonstrate accountability. Monitoring is critical for detecting unauthorized access.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      193,
      181,
      202,
      169,
      176
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 19,
    "question": "Model inversion attacks attempt to do which of the following?",
    "choice_a": "Delete training data",
    "choice_b": "Infer sensitive attributes from trained models",
    "choice_c": "Encrypt AI outputs",
    "choice_d": "Prevent anonymization",
    "correct_answer": "B",
    "explanation": "Model inversion attacks analyze model outputs to infer sensitive information about training data. Attackers may reconstruct features such as images or attributes. Mitigation includes differential privacy, access controls, and output limitation.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      208,
      207,
      206
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 20,
    "question": "Which combination best demonstrates end-to-end privacy engineering?",
    "choice_a": "Data minimization, access control, logging, and anonymization",
    "choice_b": "Privacy policy only",
    "choice_c": "Encryption plus vendor contract",
    "choice_d": "Incident response plan only",
    "correct_answer": "A",
    "explanation": "End-to-end privacy engineering integrates layered controls across the lifecycle. Minimization reduces collection, IAM restricts access, logging detects misuse, and anonymization protects analytics. Together, these controls provide comprehensive protection.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      206,
      173,
      169,
      172,
      202
    ],
    "source": "363803_Assessment Test"
  },
  {
    "id": 21,
    "question": "What is the primary purpose of privacy governance in an organization?",
    "choice_a": "To implement security controls for IT systems",
    "choice_b": "To ensure alignment of privacy practices with business objectives and legal requirements",
    "choice_c": "To eliminate all privacy risks",
    "choice_d": "To centralize all data processing activities",
    "correct_answer": "B",
    "explanation": "Privacy governance establishes the framework through which an organization manages personal information in alignment with its strategic objectives, regulatory obligations, and stakeholder expectations. It defines roles, policies, and oversight mechanisms to ensure that privacy is consistently addressed across the enterprise. It does not eliminate all risk; instead, it ensures that risks are identified, managed, and monitored appropriately.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      6,
      7,
      4,
      33
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 22,
    "question": "Which of the following best describes personal information?",
    "choice_a": "Any data stored in a database",
    "choice_b": "Data that is encrypted",
    "choice_c": "Information that identifies or can be linked to an individual",
    "choice_d": "Only financial and medical records",
    "correct_answer": "C",
    "explanation": "Personal information encompasses any data that can directly or indirectly identify an individual, including names, identifiers, location data, and behavioral attributes. It is broader than just sensitive categories such as financial or medical records. It includes any information that can reasonably be associated with a person, either alone or in combination with other data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      20,
      35,
      23,
      25
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 23,
    "question": "Under GDPR, which of the following is NOT a lawful basis for processing personal data?",
    "choice_a": "Consent",
    "choice_b": "Contractual necessity",
    "choice_c": "Legitimate interests",
    "choice_d": "Business convenience",
    "correct_answer": "D",
    "explanation": "GDPR specifies six lawful bases for processing personal data: consent, contract, legal obligation, vital interests, public task, and legitimate interests. Business convenience is not recognized as a lawful basis, emphasizing that organizations must justify processing with clearly defined legal grounds rather than operational preference or efficiency.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      23,
      26,
      22,
      34,
      33
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 24,
    "question": "Which privacy principle requires that personal data be collected only for specific, defined purposes?",
    "choice_a": "Transparency",
    "choice_b": "Purpose limitation",
    "choice_c": "Data minimization",
    "choice_d": "Accountability",
    "correct_answer": "B",
    "explanation": "Purpose limitation requires organizations to define and document the specific purposes for which personal data is collected and to ensure that data is not used in ways incompatible with those purposes. This principle prevents function creep and helps maintain trust by ensuring that individuals’ data is not repurposed without appropriate justification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      26,
      33,
      21,
      22
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 25,
    "question": "What is the primary responsibility of the first line of defense in privacy governance?",
    "choice_a": "Conduct independent audits",
    "choice_b": "Define policies and standards",
    "choice_c": "Implement and operate privacy controls",
    "choice_d": "Report to regulators",
    "correct_answer": "C",
    "explanation": "The first line of defense consists of business and operational teams that handle personal information in their daily activities. These teams are responsible for implementing privacy controls, adhering to policies, and managing risks across their processes. They are accountable for ensuring that personal data is handled appropriately at the point of use.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      33,
      39,
      47,
      1
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 26,
    "question": "Which of the following is a key characteristic of valid consent under GDPR?",
    "choice_a": "Implied through inactivity",
    "choice_b": "Freely given and specific",
    "choice_c": "Permanent and irrevocable",
    "choice_d": "Required for all processing activities",
    "correct_answer": "B",
    "explanation": "Valid consent under the GDPR must be freely given, specific, informed, and unambiguous, and, in some cases, explicit. It must also be revocable at any time. Consent cannot be assumed through silence or inactivity, and it is only one of several lawful bases for processing, not a universal requirement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      26,
      23,
      34,
      50
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 27,
    "question": "What is the primary role of the second line of defense?",
    "choice_a": "Execute business processes",
    "choice_b": "Provide independent assurance",
    "choice_c": "Establish policies and monitor compliance",
    "choice_d": "Perform system administration",
    "correct_answer": "C",
    "explanation": "The second line of defense includes privacy, compliance, and risk management functions that define policies, provide guidance, and monitor adherence to requirements. They support the first line by interpreting regulations, advising on risks, and ensuring that controls are appropriately designed and functioning.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      3,
      10,
      5,
      33,
      1
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 28,
    "question": "Which document describes how an organization collects, uses, and shares personal information externally?",
    "choice_a": "Internal audit report",
    "choice_b": "Risk register",
    "choice_c": "Privacy notice",
    "choice_d": "Incident log",
    "correct_answer": "C",
    "explanation": "A privacy notice, also known as a notice of privacy practices (NOPP), informs individuals about how their personal information is collected, used, shared, and protected. It is a key mechanism for transparency and is often legally required. It differs from internal documents in that it focuses on external communication with data subjects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      22,
      4,
      31,
      32
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 29,
    "question": "What is the main objective of privacy by design?",
    "choice_a": "Add privacy controls after deployment",
    "choice_b": "Minimize system costs",
    "choice_c": "Embed privacy into system from the start",
    "choice_d": "Eliminate the need for consent",
    "correct_answer": "C",
    "explanation": "Privacy by design requires that privacy considerations be incorporated into systems, processes, and products from the outset, rather than added later. This proactive approach reduces risk, improves compliance, and ensures that privacy protections are integral to how systems operate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      43,
      24,
      1,
      8
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 30,
    "question": "Which of the following best describes data minimization?",
    "choice_a": "Encrypt all data",
    "choice_b": "Retain data indefinitely",
    "choice_c": "Collect only the data necessary for a specific purpose",
    "choice_d": "Share data across departments",
    "correct_answer": "C",
    "explanation": "Data minimization limits the collection, use, and retention of personal data to what is strictly necessary to achieve a defined purpose. This reduces exposure, lowers risk, and supports compliance with regulatory requirements that discourage excessive data collection.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      23,
      26,
      28,
      43,
      22
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 31,
    "question": "What is the purpose of a risk register in a privacy program?",
    "choice_a": "Store personal data",
    "choice_b": "Track identified risks and treatment decisions",
    "choice_c": "Log system events",
    "choice_d": "Record employee training",
    "correct_answer": "B",
    "explanation": "A risk register is a structured record of identified risks, their likelihood and impact, and the decisions made to mitigate or accept them. In a privacy context, it helps ensure that risks to individuals are systematically identified, evaluated, and managed over time.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      11,
      31,
      9,
      1,
      8
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 32,
    "question": "Which of the following is the best example of transparency?",
    "choice_a": "Encrypting data",
    "choice_b": "Publishing a clear privacy notice",
    "choice_c": "Conducting internal audits",
    "choice_d": "Limiting data access",
    "correct_answer": "B",
    "explanation": "Transparency involves clearly informing individuals about how their personal data is collected, used, and shared. A privacy notice is a primary tool for achieving transparency, enabling individuals to understand and exercise their rights.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      34,
      4,
      26,
      43
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 33,
    "question": "What is the primary function of internal audit in privacy governance?",
    "choice_a": "Implement controls",
    "choice_b": "Monitor daily operations",
    "choice_c": "Provide independent assurance",
    "choice_d": "Define policies",
    "correct_answer": "C",
    "explanation": "Internal audit serves as the third line of defense and provides independent assurance that governance, risk management, and control processes are effective. It evaluates whether privacy controls are properly designed and operating as intended.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      1,
      5,
      47,
      7
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 34,
    "question": "Which of the following best describes “legal basis” under GDPR?",
    "choice_a": "A justification for collecting personal data",
    "choice_b": "A contractual agreement with vendors",
    "choice_c": "A privacy policy requirement",
    "choice_d": "A security control framework",
    "correct_answer": "A",
    "explanation": "A legal basis under GDPR is the lawful justification for processing personal data. Organizations must identify and document a valid legal basis before processing, ensuring that the activity is permitted under the regulation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      26,
      22,
      34,
      32
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 35,
    "question": "What is the primary purpose of a Data Protection Impact Assessment (DPIA)?",
    "choice_a": "Monitor employee performance",
    "choice_b": "Identify and mitigate privacy risks in processing activities",
    "choice_c": "Audit financial systems",
    "choice_d": "Classify data assets",
    "correct_answer": "B",
    "explanation": "A DPIA is a structured process used to identify, assess, and mitigate risks to individuals arising from data processing activities, particularly those that are high risk. It supports compliance and helps organizations proactively address privacy concerns.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      21,
      43,
      9,
      1
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 36,
    "question": "Which of the following best describes accountability in privacy governance?",
    "choice_a": "Delegating all responsibility to IT",
    "choice_b": "Documenting and demonstrating compliance with privacy requirements",
    "choice_c": "Eliminating all risks",
    "choice_d": "Avoiding regulatory oversight",
    "correct_answer": "B",
    "explanation": "Accountability requires organizations not only to comply with privacy requirements but also to demonstrate that compliance through documentation, controls, and evidence. This includes maintaining records, conducting assessments, and showing that appropriate governance is in place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      3,
      5,
      1,
      7
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 37,
    "question": "Which privacy law introduced the concept of Sensitive Personal Information (SPI) in California?",
    "choice_a": "HIPAA",
    "choice_b": "GDPR",
    "choice_c": "CPRA",
    "choice_d": "FCRA",
    "correct_answer": "C",
    "explanation": "The California Privacy Rights Act (CPRA) expanded the CCPA by introducing the concept of Sensitive Personal Information (SPI), which includes categories such as precise geolocation data and financial data. It also provides additional rights to limit the use of such information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      19,
      22,
      23,
      20
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 38,
    "question": "What is the primary purpose of privacy documentation?",
    "choice_a": "Replace operational controls",
    "choice_b": "Provide evidence and guidance for consistent practices",
    "choice_c": "Eliminate audits",
    "choice_d": "Reduce system complexity",
    "correct_answer": "B",
    "explanation": "Privacy documentation, including policies, procedures, and records, ensures consistent practices and provides evidence of compliance. It supports governance, facilitates audits, and helps organizations demonstrate accountability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      10,
      33,
      1,
      57
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 39,
    "question": "Which of the following best describes the difference between data and information?",
    "choice_a": "Data is always structured; information is not",
    "choice_b": "Data is raw; information is data with context and meaning",
    "choice_c": "Information is always digital",
    "choice_d": "There is no difference",
    "correct_answer": "B",
    "explanation": "Data consists of raw values or observations, while information is created when data is processed and interpreted within a context. This distinction is important because privacy obligations typically apply to meaningful information about individuals.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      19,
      4,
      2,
      25
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 40,
    "question": "Which lifecycle phase focuses on evaluating control effectiveness and identifying gaps?",
    "choice_a": "Initiation",
    "choice_b": "Design",
    "choice_c": "Monitoring",
    "choice_d": "Implementation",
    "correct_answer": "C",
    "explanation": "The monitoring phase involves assessing the performance and effectiveness of privacy controls through metrics, audits, and reviews. It identifies gaps, weaknesses, and areas for improvement, enabling the organization to maintain compliance and strengthen its privacy program over time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      55,
      1,
      9,
      31
    ],
    "source": "363803_Ch01"
  },
  {
    "id": 41,
    "question": "Which function is typically responsible for overseeing privacy compliance across an organization?",
    "choice_a": "Chief Financial Officer",
    "choice_b": "Data Owner",
    "choice_c": "Data Protection Officer or Privacy Officer",
    "choice_d": "Internal Audit",
    "correct_answer": "C",
    "explanation": "The Data Protection Officer (DPO) or Privacy Officer is tasked with monitoring compliance with privacy laws and internal policies, advising leadership, and serving as a point of contact for regulators. While other roles contribute, the DPO provides centralized oversight and ensures alignment with regulatory obligations.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      43,
      7,
      41,
      1,
      3
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 42,
    "question": "Which organizational structure most effectively embeds privacy into daily operations?",
    "choice_a": "Fully centralized privacy team",
    "choice_b": "Fully decentralized approach with no coordination",
    "choice_c": "Federated model with central governance and distributed execution",
    "choice_d": "Outsourced privacy function",
    "correct_answer": "C",
    "explanation": "A federated model balances centralized governance with decentralized execution, allowing business units to manage privacy risks within their operations while adhering to enterprise standards. This approach improves scalability, accountability, and integration of privacy into business processes compared to purely centralized or decentralized models.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      47,
      1,
      16,
      33
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 43,
    "question": "What is the primary objective of vendor risk assessments in privacy operations?",
    "choice_a": "To evaluate vendor profitability",
    "choice_b": "To ensure vendors comply with privacy and data protection requirements",
    "choice_c": "To reduce procurement timelines",
    "choice_d": "To eliminate all third-party relationships",
    "correct_answer": "B",
    "explanation": "Vendor risk assessments evaluate whether third parties have adequate controls to protect personal data and comply with applicable regulations. This includes reviewing security measures, data handling practices, and legal commitments. The goal is to reduce the organization’s exposure to regulatory, operational, and reputational risks stemming from vendor relationships.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      52,
      51,
      50,
      49,
      47
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 44,
    "question": "Which document most directly governs a vendor’s handling of personal data?",
    "choice_a": "Service Level Agreement (SLA)",
    "choice_b": "Data Processing Agreement (DPA)",
    "choice_c": "Statement of Work (SOW)",
    "choice_d": "Non-disclosure Agreement (NDA)",
    "correct_answer": "B",
    "explanation": "A Data Processing Agreement (DPA) specifies how a vendor processes personal data, including instructions, security requirements, breach-notification obligations, and restrictions on data use. While other documents can include related provisions, the DPA is the primary legal instrument for ensuring compliant data processing.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      50,
      51,
      26,
      25,
      33
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 45,
    "question": "What is the key purpose of incident management in privacy operations?",
    "choice_a": "To eliminate all system vulnerabilities",
    "choice_b": "To ensure timely detection, response, and mitigation of privacy incidents",
    "choice_c": "To assign blame for data breaches",
    "choice_d": "To automate compliance reporting",
    "correct_answer": "B",
    "explanation": "Incident management focuses on identifying and responding to privacy incidents quickly to limit harm to individuals and the organization. This includes detection, containment, investigation, and recovery. Effective incident management also supports compliance with breach-notification requirements and helps prevent recurrence by capturing lessons learned.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      53,
      54,
      57,
      5,
      13
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 46,
    "question": "Which of the following is a required component of most breach notification laws?",
    "choice_a": "Notification only if financial loss occurs",
    "choice_b": "Notification only to internal stakeholders",
    "choice_c": "Notification only if encryption was not used",
    "choice_d": "Notification within a defined timeframe after discovery",
    "correct_answer": "D",
    "explanation": "Many privacy regulations mandate that organizations notify regulators and/or affected individuals within a specified timeframe after becoming aware of a breach. This requirement ensures timely awareness and enables affected parties to take protective actions. The exact timeframe and conditions vary by jurisdiction.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      57,
      26,
      27,
      29,
      53
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 47,
    "question": "Which role is typically responsible for approving vendor onboarding from a privacy perspective?",
    "choice_a": "Procurement",
    "choice_b": "Privacy or compliance function",
    "choice_c": "IT operations",
    "choice_d": "Marketing",
    "correct_answer": "B",
    "explanation": "While procurement manages vendor selection and contracting, the privacy or compliance function evaluates whether the vendor meets data protection requirements. This includes reviewing contractual terms, security controls, and regulatory alignment before approving onboarding.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      50,
      51,
      32,
      33,
      5
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 48,
    "question": "What is the primary purpose of a data subject access request (DSAR)?",
    "choice_a": "To allow individuals to access their personal data held by an organization",
    "choice_b": "To request deletion of all company data",
    "choice_c": "To audit internal systems",
    "choice_d": "To monitor employee behavior",
    "correct_answer": "A",
    "explanation": "A DSAR enables individuals to obtain information about the personal data an organization holds about them, including how it is used and shared. This supports transparency and is a core right under many privacy laws, including the GDPR and the CCPA/CPRA.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      56,
      26,
      22,
      28,
      34
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 49,
    "question": "Which process ensures that data subject requests are handled consistently and within legal timeframes?",
    "choice_a": "Change management",
    "choice_b": "Request fulfillment workflow",
    "choice_c": "Vendor onboarding",
    "choice_d": "Data classification",
    "correct_answer": "B",
    "explanation": "A defined request fulfillment workflow standardizes how requests are received, validated, processed, and completed. This ensures consistency, reduces errors, and helps organizations meet statutory deadlines for responding to data subject requests.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      26,
      33,
      34,
      38
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 50,
    "question": "Which metric is most useful for evaluating the effectiveness of privacy incident response?",
    "choice_a": "Number of employees trained",
    "choice_b": "Number of vendors onboarded",
    "choice_c": "Mean time to detect and respond to incidents",
    "choice_d": "Total IT budget",
    "correct_answer": "C",
    "explanation": "Metrics such as mean time to detect (MTTD) and mean time to respond (MTTR) provide direct insight into how quickly an organization can identify and address incidents. Faster response times typically reduce impact and demonstrate operational maturity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      53,
      11,
      5,
      13
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 51,
    "question": "Which of the following best describes “privacy by design” in operations?",
    "choice_a": "Applying privacy controls only after deployment",
    "choice_b": "Embedding privacy considerations into processes and systems from the start of their development",
    "choice_c": "Delegating privacy solely to legal teams",
    "choice_d": "Limiting privacy to regulatory compliance",
    "correct_answer": "B",
    "explanation": "Privacy by design requires integrating privacy principles into system and process development from the beginning, rather than retrofitting controls later. This approach reduces risk, improves compliance, and enhances trust by proactively addressing privacy concerns.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      24,
      43,
      1,
      10
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 52,
    "question": "What is the primary risk of inadequate vendor oversight?",
    "choice_a": "Increased employee turnover",
    "choice_b": "Unauthorized or non-compliant processing of personal data",
    "choice_c": "Reduced system performance",
    "choice_d": "Higher marketing costs",
    "correct_answer": "B",
    "explanation": "Without proper oversight, vendors might mishandle personal data, fail to meet regulatory requirements, or introduce security vulnerabilities. Since organizations remain accountable for their vendors’ actions, inadequate oversight can result in legal penalties and reputational damage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      51,
      12,
      2
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 53,
    "question": "Which activity is essential when managing cross-border data transfers by vendors?",
    "choice_a": "Reducing vendor costs",
    "choice_b": "Ensuring appropriate transfer mechanisms (e.g., SCCs) are in place",
    "choice_c": "Limiting vendor access to financial data only",
    "choice_d": "Eliminating all international vendors",
    "correct_answer": "B",
    "explanation": "Cross-border data transfers are subject to legal restrictions in many jurisdictions. Mechanisms such as standard contractual clauses (SCCs) or adequacy decisions ensure that transferred data receives appropriate protection consistent with regulatory requirements.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      50,
      26,
      29,
      51,
      52
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 54,
    "question": "Which team typically coordinates communication during a privacy incident?",
    "choice_a": "Human resources",
    "choice_b": "Incident response or crisis management team",
    "choice_c": "Procurement",
    "choice_d": "Sales",
    "correct_answer": "B",
    "explanation": "The incident response or crisis management team is responsible for coordinating communications with internal stakeholders, regulators, customers, and the public. Effective communication is critical to managing reputational impact and ensuring regulatory compliance.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      54,
      5,
      12,
      53,
      57
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 55,
    "question": "Which of the following best describes the primary purpose of data minimization in a privacy program?",
    "choice_a": "To ensure that all available data is collected to maximize analytical value",
    "choice_b": "To encrypt all personal data at rest and in transit",
    "choice_c": "To centralize all personal data into a single repository for easier governance",
    "choice_d": "To limit the collection, use, and retention of personal data to what is necessary for a defined purpose",
    "correct_answer": "D",
    "explanation": "Data minimization is a foundational privacy principle requiring organizations to collect, use, and retain only the personal data strictly necessary to achieve a specified legitimate purpose. This reduces exposure, limits the impact of potential breaches, and supports compliance with regulations such as GDPR.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      23,
      26,
      28,
      43,
      1
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 56,
    "question": "Which factor determines whether a data subject request can be denied?",
    "choice_a": "Organizational preference",
    "choice_b": "Legal exemptions or limitations defined by applicable laws",
    "choice_c": "Request complexity",
    "choice_d": "Cost of processing the request",
    "correct_answer": "B",
    "explanation": "Privacy laws often include specific exemptions that allow organizations to deny or limit requests, such as those protecting trade secrets or those that require compliance with legal obligations. Decisions must be based on these legal criteria, not operational convenience.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      26,
      28,
      25,
      34
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 57,
    "question": "Which of the following best aligns with the principle of accountability in vendor management?",
    "choice_a": "Transferring all liability to the vendor through contracts",
    "choice_b": "Relying solely on vendor certifications",
    "choice_c": "Continuously monitoring vendor compliance and performance",
    "choice_d": "Limiting vendor access to non-sensitive data only",
    "correct_answer": "C",
    "explanation": "Accountability requires organizations to actively oversee vendors’ activities rather than merely rely on contractual terms or certifications. Continuous monitoring, audits, and performance reviews ensure that vendors maintain compliance over time, reflecting the organization’s ongoing responsibility for outsourced processing.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      52,
      49,
      51,
      50,
      55
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 58,
    "question": "An organization experiences a data breach involving encrypted personal data. Under most regulations, when is notification typically required?",
    "choice_a": "Always required regardless of risk",
    "choice_b": "Only if encryption keys were compromised or the risk to individuals exists",
    "choice_c": "Never required if encryption was used",
    "choice_d": "Only if regulators request it",
    "correct_answer": "B",
    "explanation": "Many regulations adopt a risk-based approach to breach notification. If strong encryption renders the data unintelligible and keys remain secure, the risk to individuals can be minimal, and notification might not be required. However, if keys are compromised or risk remains, notification obligations are triggered.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      26,
      27
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 59,
    "question": "Which operational control best supports the timely fulfillment of data subject deletion requests?",
    "choice_a": "Data retention schedules aligned with deletion workflows",
    "choice_b": "Increased storage capacity",
    "choice_c": "Manual approval processes only",
    "choice_d": "Vendor audits",
    "correct_answer": "A",
    "explanation": "Well-defined data retention schedules, combined with automated or standardized deletion workflows, ensure that personal data is removed in accordance with both regulatory requirements and data subject requests. This reduces delays, minimizes errors, and supports compliance with legal obligations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      33,
      43,
      35,
      26
    ],
    "source": "363803_Ch02"
  },
  {
    "id": 60,
    "question": "What is the primary purpose of a privacy risk management program?",
    "choice_a": "To eliminate all risks associated with personal data",
    "choice_b": "To ensure compliance with all security standards",
    "choice_c": "To identify and manage risks to individuals’ privacy",
    "choice_d": "To maximize data collection for business value",
    "correct_answer": "C",
    "explanation": "Privacy risk management focuses on identifying, analyzing, and addressing risks arising from the processing of personal data, particularly those affecting individuals’ rights and freedoms. While compliance and security are important components, the central objective is to protect individuals from harm, such as misuse, unauthorized disclosure, or unfair processing.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      59,
      58,
      90,
      63,
      68
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 61,
    "question": "Which of the following best defines a vulnerability?",
    "choice_a": "A potential event that could cause harm",
    "choice_b": "A weakness that can be exploited by a threat",
    "choice_c": "The financial impact of a security incident",
    "choice_d": "A control designed to reduce risk",
    "correct_answer": "B",
    "explanation": "A vulnerability is a weakness in a system, process, or control environment that a threat can exploit. For example, poor access controls or unencrypted data storage can be vulnerabilities. Threats exploit vulnerabilities to create risk, while controls are implemented to reduce or eliminate those weaknesses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      81,
      79,
      64,
      84,
      69
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 62,
    "question": "Which step in the risk management lifecycle involves estimating the likelihood and impact of identified risks?",
    "choice_a": "Risk identification",
    "choice_b": "Risk analysis",
    "choice_c": "Risk treatment",
    "choice_d": "Risk monitoring",
    "correct_answer": "B",
    "explanation": "Risk analysis is the stage in which identified risks are evaluated based on their likelihood of occurrence and potential impact. This step provides the basis for prioritizing risks and determining appropriate treatment strategies. Identification simply catalogs risks, while treatment and monitoring occur later in the lifecycle.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      59,
      69,
      70,
      62,
      72
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 63,
    "question": "What is the primary objective of a Privacy Impact Assessment (PIA)?",
    "choice_a": "To certify compliance with ISO standards",
    "choice_b": "To evaluate system performance",
    "choice_c": "To assess risks to personal data and individuals",
    "choice_d": "To identify all system vulnerabilities",
    "correct_answer": "C",
    "explanation": "A PIA is designed to evaluate how a project, system, or process affects personal data and to identify risks to individuals. It focuses on data flows, processing activities, and potential harms, rather than purely technical vulnerabilities or system performance metrics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      59,
      75,
      63
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 64,
    "question": "Which of the following best describes risk appetite?",
    "choice_a": "The amount of risk an organization is willing to accept",
    "choice_b": "The level of risk that must be eliminated",
    "choice_c": "The maximum financial loss an organization can sustain",
    "choice_d": "The number of risks identified in an assessment",
    "correct_answer": "A",
    "explanation": "Risk appetite refers to the level and type of risk an organization is willing to accept in pursuit of its objectives. It guides decision-making during risk treatment and helps ensure consistency in how risks are evaluated and managed across the organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      59,
      83,
      63
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 65,
    "question": "Which of the following is an example of risk transfer?",
    "choice_a": "Encrypting sensitive data",
    "choice_b": "Discontinuing a high-risk process",
    "choice_c": "Purchasing cyber insurance",
    "choice_d": "Accepting residual risk",
    "correct_answer": "C",
    "explanation": "Risk transfer involves shifting some or all of the financial or operational impact of a risk to another party, typically through insurance or contractual agreements. Encryption is risk mitigation, discontinuation is avoidance, and acceptance involves taking no further action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 66,
    "question": "What distinguishes a Data Protection Impact Assessment (DPIA) from a general PIA?",
    "choice_a": "DPIAs are only used for financial data",
    "choice_b": "DPIAs are optional, while PIAs are mandatory",
    "choice_c": "DPIAs focus only on technical vulnerabilities",
    "choice_d": "DPIAs assess risks to individuals’ rights and freedoms under GDPR",
    "correct_answer": "D",
    "explanation": "A DPIA, as defined under the GDPR, specifically evaluates risks to individuals’ rights and freedoms arising from the processing of personal data. While similar to PIAs, DPIAs have a stronger regulatory basis and focus on broader impacts beyond technical risks, including fairness and proportionality.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      88,
      89,
      59,
      74
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 67,
    "question": "Which activity is most important during risk identification?",
    "choice_a": "Estimating financial loss",
    "choice_b": "Assigning risk ownership",
    "choice_c": "Identifying assets, threats, and vulnerabilities",
    "choice_d": "Selecting risk treatment strategies",
    "correct_answer": "C",
    "explanation": "Risk identification involves determining which assets exist, which threats could affect them, and which vulnerabilities could be exploited. This foundational step ensures that subsequent analysis and treatment are based on a comprehensive understanding of potential risk scenarios.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      68,
      59,
      64,
      63,
      79
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 68,
    "question": "Which of the following best describes residual risk?",
    "choice_a": "Risk remaining after controls are applied",
    "choice_b": "Risk that has not yet been identified",
    "choice_c": "Risk transferred to a third party",
    "choice_d": "Risk that has been fully eliminated",
    "correct_answer": "A",
    "explanation": "Residual risk is the level of risk that remains after risk treatment measures have been implemented. Since it is rarely possible to eliminate risk entirely, organizations must decide whether the remaining risk is acceptable based on their risk appetite.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      84,
      65,
      83,
      59,
      58
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 69,
    "question": "What is the primary goal of privacy training and awareness programs?",
    "choice_a": "To eliminate insider threats",
    "choice_b": "To ensure employees understand and follow privacy practices",
    "choice_c": "To replace formal policies",
    "choice_d": "To certify employees in privacy frameworks",
    "correct_answer": "B",
    "explanation": "Privacy training and awareness programs aim to ensure that personnel understand their responsibilities for handling personal data and can recognize and respond to privacy risks. While training can reduce insider threats, it does not eliminate them and does not replace formal policies.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      76,
      77,
      78,
      102,
      92
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 70,
    "question": "Which of the following best describes a threat?",
    "choice_a": "A weakness in a system",
    "choice_b": "A control failure",
    "choice_c": "A potential event that could cause harm",
    "choice_d": "A quantified risk value",
    "correct_answer": "C",
    "explanation": "A threat is any potential event or action that could cause harm to an asset, such as unauthorized access or data leakage. It differs from a vulnerability, which is the weakness that enables the threat to materialize.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      79,
      68,
      63,
      62,
      64
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 71,
    "question": "Which risk analysis method uses descriptive categories such as high, medium, and low?",
    "choice_a": "Quantitative analysis",
    "choice_b": "Qualitative analysis",
    "choice_c": "Statistical modeling",
    "choice_d": "Semi-quantitative analysis",
    "correct_answer": "B",
    "explanation": "Qualitative risk analysis uses descriptive scales to assess likelihood and impact, making it easier to apply when precise numerical data is unavailable. Quantitative methods use numerical values and statistical techniques.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      70,
      69,
      72,
      60,
      59
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 72,
    "question": "Why is asset valuation important in risk management?",
    "choice_a": "It helps determine potential impact and prioritization",
    "choice_b": "It determines the number of threats",
    "choice_c": "It defines compliance requirements",
    "choice_d": "It eliminates vulnerabilities",
    "correct_answer": "A",
    "explanation": "Asset valuation helps organizations understand the importance of data and systems, which in turn informs the potential impact of a risk event. This enables prioritization of risk treatment efforts based on business significance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      58,
      68,
      69,
      71,
      67
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 73,
    "question": "Which of the following best represents risk avoidance?",
    "choice_a": "Implementing encryption controls",
    "choice_b": "Accepting low-level risk",
    "choice_c": "Eliminating the activity that creates the risk",
    "choice_d": "Purchasing insurance",
    "correct_answer": "C",
    "explanation": "Risk avoidance involves eliminating the source of risk entirely, such as discontinuing a high-risk data processing activity. This differs from mitigation, which reduces risk, and transfer, which shifts it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59,
      84,
      82
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 74,
    "question": "Which factor is most important when determining appropriate risk treatment?",
    "choice_a": "Employee preferences",
    "choice_b": "Cost-benefit considerations",
    "choice_c": "Number of vulnerabilities",
    "choice_d": "Vendor capabilities",
    "correct_answer": "B",
    "explanation": "Risk treatment decisions are guided by cost-benefit analysis, balancing the cost of implementing controls against the risk’s potential impact. This ensures that resources are used efficiently while maintaining acceptable risk levels.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      85,
      65,
      83,
      59,
      82
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 75,
    "question": "Which of the following is the best example of a privacy-specific risk?",
    "choice_a": "Server hardware failure",
    "choice_b": "Network latency issues",
    "choice_c": "Software performance degradation",
    "choice_d": "Unauthorized profiling of individuals",
    "correct_answer": "D",
    "explanation": "Unauthorized profiling directly impacts individuals’ rights and freedoms, making it a privacy-specific risk. The other options are operational or technical risks that might not directly affect personal privacy.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      75,
      64,
      59,
      73,
      58
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 76,
    "question": "What is the role of risk ownership?",
    "choice_a": "To eliminate all risks",
    "choice_b": "To assign accountability for managing specific risks",
    "choice_c": "To perform all risk assessments",
    "choice_d": "To approve all security controls",
    "correct_answer": "B",
    "explanation": "Risk ownership ensures that specific individuals are accountable for monitoring, evaluating, and treating risks. This accountability supports effective governance and ensures that risks are actively managed rather than ignored.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      82,
      59,
      66,
      60,
      58
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 77,
    "question": "Why is continuous monitoring important in risk management?",
    "choice_a": "It reduces compliance requirements",
    "choice_b": "It eliminates the need for assessments",
    "choice_c": "It ensures risks are updated as conditions change",
    "choice_d": "It guarantees zero incidents",
    "correct_answer": "C",
    "explanation": "Risks evolve due to changes in technology, threats, and business processes. Continuous monitoring ensures that risk assessments remain current and that new risks are identified and addressed promptly.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      66,
      61,
      60,
      59,
      84
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 78,
    "question": "Which of the following best explains why privacy risk cannot be assessed solely using traditional information security methods?",
    "choice_a": "Privacy risk includes impacts to individuals beyond organizational harm",
    "choice_b": "Privacy risk is always financial in nature",
    "choice_c": "Privacy risk focuses on systems rather than data",
    "choice_d": "Privacy risk does not involve threats or vulnerabilities",
    "correct_answer": "A",
    "explanation": "Traditional information security risk focuses primarily on organizational impact (e.g., financial loss, operational disruption). Privacy risk extends beyond this to include harm to individuals, such as loss of autonomy, discrimination, or reputational damage. Therefore, additional considerations are required.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      73,
      75,
      86,
      64,
      59
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 79,
    "question": "During a DPIA, which factor is most critical when evaluating risk severity?",
    "choice_a": "System uptime requirements",
    "choice_b": "Volume of data storage",
    "choice_c": "Potential impact on individuals’ rights and freedoms",
    "choice_d": "Number of security controls implemented",
    "correct_answer": "C",
    "explanation": "Under GDPR, DPIAs focus on assessing risks to individuals’ rights and freedoms. While technical factors such as data volume and controls are relevant, the most critical determinant of severity is the potential harm to individuals, including legal, social, and ethical impacts.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      73,
      64,
      59,
      70,
      82
    ],
    "source": "363803_Ch03"
  },
  {
    "id": 80,
    "question": "A privacy leader adopts a recognized privacy framework instead of creating a new one internally. What is the primary benefit of this decision?",
    "choice_a": "Eliminates need for privacy metrics",
    "choice_b": "Provides structured governance aligned with accepted practices",
    "choice_c": "Guarantees regulatory compliance",
    "choice_d": "Reduces documentation requirements",
    "correct_answer": "B",
    "explanation": "Established privacy frameworks provide structured governance models, terminology, and control guidance that align with recognized industry practices. This helps organizations design consistent privacy programs and demonstrate alignment with regulatory expectations. Frameworks do not eliminate metrics, documentation, or compliance activities, but they provide a foundation that improves program maturity and defensibility.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      90,
      87,
      88,
      89,
      86
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 81,
    "question": "Which of the following would most likely be considered audit evidence in a privacy program?",
    "choice_a": "Data subject request processing logs",
    "choice_b": "IT hardware inventory",
    "choice_c": "Software procurement budget",
    "choice_d": "Marketing analytics dashboard",
    "correct_answer": "A",
    "explanation": "Data subject request logs document how the organization receives, authenticates, and responds to requests. These records demonstrate compliance with regulatory timelines and operational procedures, making them valuable audit evidence. While other items might be useful for broader governance, they do not directly demonstrate the operation of privacy control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      91,
      97,
      96,
      95
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 82,
    "question": "Which metric is the best example of a key risk indicator (KRI)?",
    "choice_a": "Percentage of employees completing privacy training",
    "choice_b": "Mean time to detect privacy incidents",
    "choice_c": "Number of privacy policies approved",
    "choice_d": "Number of privacy audits completed",
    "correct_answer": "B",
    "explanation": "KRIs serve as leading indicators that signal changes in risk exposure. Mean time to detect privacy incidents reflects how long personal data might remain exposed during an event. Longer detection times increase risk, making this metric useful for predicting potential negative outcomes.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      94,
      92,
      66,
      101,
      82
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 83,
    "question": "What is the primary purpose of maintaining privacy artifacts such as PIAs and consent records?",
    "choice_a": "Reduce operational overhead",
    "choice_b": "Replace risk assessments",
    "choice_c": "Eliminate the need for audits",
    "choice_d": "Demonstrate control effectiveness and compliance",
    "correct_answer": "D",
    "explanation": "Privacy artifacts provide objective evidence that controls and processes exist and are operating. Auditors and management rely on documentation and records, such as PIAs, consent records, and incident reports, to confirm compliance and evaluate the effectiveness of privacy governance activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      91,
      95,
      74,
      97,
      96
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 84,
    "question": "Which statement best describes a KCI?",
    "choice_a": "Measures strategic business outcomes",
    "choice_b": "Measures operational efficiency",
    "choice_c": "Measures effectiveness of controls",
    "choice_d": "Measures regulatory changes",
    "correct_answer": "C",
    "explanation": "Key control indicators (KCIs) evaluate whether specific controls are functioning properly. For example, measuring the percentage of systems enforcing data minimization directly assesses control effectiveness. KCIs focus on operational control performance rather than strategy or risk prediction.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      94,
      92,
      95,
      102,
      96
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 85,
    "question": "Executive leadership requests metrics that demonstrate progress toward privacy-related strategic goals. Which metric type should be used?",
    "choice_a": "KPI",
    "choice_b": "KRI",
    "choice_c": "KCI",
    "choice_d": "KGI",
    "correct_answer": "D",
    "explanation": "Key goal indicators (KGIs) measure achievement of strategic objectives. Examples include reductions in privacy complaints or improved customer trust metrics. These indicators are designed for executive audiences and demonstrate whether the privacy program supports organizational goals.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      93,
      92,
      90,
      87
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 86,
    "question": "Which of the following is most appropriate for a key performance indicator (KPI)?",
    "choice_a": "Percentage of systems using encryption controls",
    "choice_b": "Time required to respond to data subject requests",
    "choice_c": "Reduction in regulatory fines",
    "choice_d": "Number of new privacy regulations",
    "correct_answer": "B",
    "explanation": "KPIs measure operational performance and efficiency. Response time for data subject requests reflects how effectively the organization performs a routine privacy process. Strategic outcomes and risk measures fall under other indicator categories.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      100,
      102
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 87,
    "question": "Which item best represents privacy program evidence?",
    "choice_a": "Data inventory documentation",
    "choice_b": "Employee productivity reports",
    "choice_c": "Office space utilization data",
    "choice_d": "Hardware depreciation schedules",
    "correct_answer": "A",
    "explanation": "A data inventory demonstrates knowledge of the locations and flows of personal information. It supports compliance with accountability requirements and provides auditors with insight into data management practices.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      91,
      99,
      96,
      97,
      95
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 88,
    "question": "Why should privacy metrics be tailored to specific audiences?",
    "choice_a": "To reduce reporting frequency",
    "choice_b": "To ensure technical metrics are hidden",
    "choice_c": "To ensure relevance to stakeholder decision-making",
    "choice_d": "To simplify metric calculations",
    "correct_answer": "C",
    "explanation": "Different stakeholders require different information. Executives need strategic indicators, while operational teams need process-level metrics. Tailoring metrics ensures that recipients receive actionable information relevant to their responsibilities.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      93,
      94,
      92,
      66,
      77
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 89,
    "question": "Which of the following is an example of a key goal indicator (KGI)?",
    "choice_a": "Reduction in privacy-related customer complaints",
    "choice_b": "Number of PIAs completed",
    "choice_c": "Time to detect privacy incidents",
    "choice_d": "Percentage of systems reviewed quarterly",
    "correct_answer": "A",
    "explanation": "KGIs measure achievement of strategic outcomes. Reducing customer complaints reflects improved trust and program effectiveness, aligning with organizational objectives.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      94,
      92,
      93
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 90,
    "question": "What is the primary purpose of trend analysis in privacy metrics?",
    "choice_a": "Track regulatory changes",
    "choice_b": "Compare frameworks",
    "choice_c": "Determine improvement or decline over time",
    "choice_d": "Replace audits",
    "correct_answer": "C",
    "explanation": "Trend analysis shows whether controls, processes, and risks are improving or deteriorating. A single data point provides limited insight, while trends enable management to make informed decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      93,
      102,
      60,
      84
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 91,
    "question": "Which document would most likely support compliance during a privacy audit?",
    "choice_a": "Product roadmap",
    "choice_b": "Marketing segmentation plan",
    "choice_c": "IT equipment warranty",
    "choice_d": "Privacy incident response report",
    "correct_answer": "D",
    "explanation": "Incident response reports document detection, containment, and resolution of privacy events. These demonstrate operational capability and regulatory compliance, making them valuable audit evidence.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      91,
      96,
      97,
      95
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 92,
    "question": "Which metric category focuses on operational efficiency and timeliness?",
    "choice_a": "KGI",
    "choice_b": "KCI",
    "choice_c": "KPI",
    "choice_d": "KRI",
    "correct_answer": "C",
    "explanation": "Key performance indicators (KPIs) measure process performance, such as response times or training completion rates. These indicators focus on operational efficiency rather than strategic outcomes or risk levels.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      102,
      95
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 93,
    "question": "An organization tracks the percentage of vendors meeting privacy requirements. This is best classified as which of the following?",
    "choice_a": "KPI",
    "choice_b": "KRI",
    "choice_c": "KCI",
    "choice_d": "KGI",
    "correct_answer": "B",
    "explanation": "Vendor compliance rates indicate risk exposure related to third parties. If fewer vendors meet requirements, risk increases, making this a key risk indicator (KRI).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      81,
      66,
      59
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 94,
    "question": "Which of the following best demonstrates layered metrics?",
    "choice_a": "Reporting the same metrics to all stakeholders",
    "choice_b": "Eliminating operational metrics",
    "choice_c": "Using only KRIs",
    "choice_d": "Providing operational metrics to technical staff and strategic metrics to executives",
    "correct_answer": "D",
    "explanation": "Layered metrics translate operational data into business-relevant indicators for different audiences. This improves decision-making and ensures stakeholders receive meaningful information.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      93,
      92,
      94,
      66,
      77
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 95,
    "question": "Which artifact would best support evidence of data minimization controls?",
    "choice_a": "HR organizational chart",
    "choice_b": "Data collection form reviews",
    "choice_c": "Employee training attendance logs",
    "choice_d": "Procurement contracts",
    "correct_answer": "B",
    "explanation": "Reviews of data collection forms demonstrate whether only necessary personal data is collected. These directly support data minimization principles and control effectiveness.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      91,
      99,
      97,
      95
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 96,
    "question": "Why are SMART criteria important for privacy metrics?",
    "choice_a": "They reduce audit scope",
    "choice_b": "They ensure metrics are actionable and meaningful",
    "choice_c": "They eliminate risk",
    "choice_d": "They standardize frameworks",
    "correct_answer": "B",
    "explanation": "SMART metrics are specific, measurable, attainable, relevant, and timely. These characteristics ensure metrics can guide decisions and accurately reflect performance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      59,
      85,
      66
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 97,
    "question": "Which indicator measures operational performance?",
    "choice_a": "KPI",
    "choice_b": "KRI",
    "choice_c": "KGI",
    "choice_d": "KCI",
    "correct_answer": "A",
    "explanation": "Key performance indicators (KPIs) measure how well processes perform. They typically track timeliness, quality, and efficiency of privacy-related activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      102,
      96
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 98,
    "question": "An organization reports: increased privacy incidents, improved detection capabilities, reduced impact severity, and faster remediation. What is the most appropriate interpretation?",
    "choice_a": "Privacy controls are failing",
    "choice_b": "Risk exposure is increasing significantly",
    "choice_c": "Program maturity is improving despite higher incident counts",
    "choice_d": "Compliance requirements are not being met",
    "correct_answer": "C",
    "explanation": "Improved detection often increases reported incident counts. Simultaneous reductions in severity and remediation time indicate better controls and maturity. The increased volume reflects improved visibility, not necessarily increased risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      69,
      59,
      66
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 99,
    "question": "Which combination best demonstrates comprehensive privacy program measurement?",
    "choice_a": "KPIs only",
    "choice_b": "KRIs and KPIs only",
    "choice_c": "KGIs only",
    "choice_d": "KPIs, KRIs, KGIs, and KCIs used together",
    "correct_answer": "D",
    "explanation": "Using all four indicator types provides layered insight. KPIs measure operations, KRIs measure risk exposure, KCIs measure control effectiveness, and KGIs measure strategic outcomes. Together, they provide complete program visibility.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      93,
      92,
      102,
      66
    ],
    "source": "363803_Ch04"
  },
  {
    "id": 100,
    "question": "Which artifact provides a structured listing of personal data assets within an organization?",
    "choice_a": "Risk register",
    "choice_b": "Control matrix",
    "choice_c": "Data inventory",
    "choice_d": "Incident log",
    "correct_answer": "C",
    "explanation": "A data inventory documents what data the organization collects and processes, including its source, purpose, location, owner, and retention requirements. This structured catalog enables organizations to understand their data landscape and supports compliance, risk management, and lifecycle governance. Risk registers and control matrices track risks and controls, not data assets themselves.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      105,
      103,
      109,
      107,
      111
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 101,
    "question": "What is the primary purpose of a data flow diagram in privacy management?",
    "choice_a": "To classify data sensitivity levels",
    "choice_b": "To visualize how data moves between entities",
    "choice_c": "To define retention schedules",
    "choice_d": "To document data lineage",
    "correct_answer": "B",
    "explanation": "Data flow diagrams illustrate how data is collected, transmitted, processed, stored, and shared. They help privacy professionals identify processing activities, third-party transfers, and potential risk points. While they might inform classification and retention, their primary purpose is to visualize data movement.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      109,
      107,
      123,
      105,
      106
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 102,
    "question": "Data classification is primarily used to do which of the following?",
    "choice_a": "Assign handling requirements based on sensitivity",
    "choice_b": "Eliminate unnecessary data collection",
    "choice_c": "Document legal bases for processing",
    "choice_d": "Define data quality metrics",
    "correct_answer": "A",
    "explanation": "Data classification categorizes information according to sensitivity and regulatory requirements. These categories drive controls such as access restrictions, encryption, monitoring, and retention. Classification supports risk-based protection, ensuring that more sensitive data receives stronger safeguards.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      110,
      111,
      115,
      121,
      103
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 103,
    "question": "Which of the following best describes data quality in a privacy context?",
    "choice_a": "The ability to encrypt data at rest",
    "choice_b": "The completeness and accuracy of stored data",
    "choice_c": "The classification of sensitive data types",
    "choice_d": "The retention period of collected data",
    "correct_answer": "B",
    "explanation": "Data quality refers to attributes such as accuracy, completeness, timeliness, and consistency. High data quality supports fair processing and reduces risks such as incorrect decisions about individuals. Encryption and classification relate to security and governance, not data quality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      103,
      111,
      105,
      119
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 104,
    "question": "Data use limitation requires that personal data:",
    "choice_a": "Be used only for specified and authorized purposes",
    "choice_b": "Be stored in a centralized repository",
    "choice_c": "Be retained indefinitely for analytics",
    "choice_d": "Be anonymized before storage",
    "correct_answer": "A",
    "explanation": "Data use limitation is a core privacy principle requiring that data be used only for the purposes identified at the time of collection or otherwise permitted by law. This prevents function creep and unauthorized secondary uses. It does not mandate anonymization or centralization, though those might be used as supporting controls.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      117,
      103,
      109,
      107,
      123
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 105,
    "question": "Which document is most helpful for identifying third-party data transfers?",
    "choice_a": "Data retention schedule",
    "choice_b": "Data flow diagram",
    "choice_c": "Access control list",
    "choice_d": "Training record",
    "correct_answer": "B",
    "explanation": "A data flow diagram shows how data moves between systems and external parties. By mapping transfers, privacy professionals can identify cross-border flows, vendor processing, and disclosure points. Retention schedules and access lists provide different types of governance information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      109,
      123,
      107,
      105,
      106
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 106,
    "question": "An organization aggregates customer data to produce statistical reports. What is the primary privacy consideration?",
    "choice_a": "Encryption key rotation",
    "choice_b": "Data retention enforcement",
    "choice_c": "Re-identification risk",
    "choice_d": "Network segmentation",
    "correct_answer": "C",
    "explanation": "Improper aggregation or small sample sizes can allow individuals to be re-identified. Privacy professionals must evaluate aggregation thresholds and residual risk before treating aggregated data as non-personal or non-sensitive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      118,
      126,
      119,
      120
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 107,
    "question": "Which activity most directly supports maintaining data accuracy?",
    "choice_a": "Periodic data validation procedures",
    "choice_b": "Increasing storage capacity",
    "choice_c": "Expanding analytics capabilities",
    "choice_d": "Implementing multi-factor authentication",
    "correct_answer": "A",
    "explanation": "Data validation ensures that information remains accurate and up to date. Regular reviews, correction processes, and automated validation controls improve data quality. Authentication and storage capacity relate to security and infrastructure rather than data accuracy.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      104,
      103,
      107,
      105
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 108,
    "question": "A data inventory should include which of the following elements?",
    "choice_a": "Encryption algorithms used",
    "choice_b": "System patch levels",
    "choice_c": "Encryption keys",
    "choice_d": "Data owner and processing purpose",
    "correct_answer": "D",
    "explanation": "A data inventory typically documents attributes such as data owner, purpose, location, retention, and data categories. These attributes support governance and lifecycle management. Technical controls, such as encryption keys, are not core inventory elements.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      105,
      103,
      117,
      107,
      109
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 109,
    "question": "Which scenario represents a violation of data use limitation?",
    "choice_a": "Using customer email addresses for unrelated marketing",
    "choice_b": "Using collected data to fulfill a customer order",
    "choice_c": "Sharing data with a contracted processor for the same purpose",
    "choice_d": "Updating inaccurate contact information",
    "correct_answer": "A",
    "explanation": "Data collected for one purpose should not be repurposed without appropriate authorization or legal basis. Using order-related contact information for unrelated marketing is a classic example of function creep and violates the purpose limitation principle.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      117,
      109,
      103,
      107,
      111
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 110,
    "question": "What is the primary benefit of maintaining an up-to-date data flow diagram?",
    "choice_a": "Improved encryption performance",
    "choice_b": "Reduced storage requirements",
    "choice_c": "Automated compliance certification",
    "choice_d": "Better visibility into processing risks",
    "correct_answer": "D",
    "explanation": "Data flow diagrams provide visibility into how data moves through systems and organizations. This visibility enables privacy professionals to identify risks such as excessive collection, unnecessary transfers, or uncontrolled processing.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      109,
      103,
      107,
      123,
      117
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 111,
    "question": "Which attribute is most closely associated with data quality?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Purpose limitation",
    "correct_answer": "B",
    "explanation": "Data integrity relates to accuracy and consistency, which are core aspects of data quality. While confidentiality and availability are important security objectives, integrity directly aligns with maintaining reliable and accurate data.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      116,
      127,
      103,
      110,
      111
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 112,
    "question": "A centralized data lake increases privacy risk primarily because it:",
    "choice_a": "Eliminates classification controls",
    "choice_b": "Reduces data availability",
    "choice_c": "Consolidates data for broader secondary use",
    "choice_d": "Prevents analytics",
    "correct_answer": "C",
    "explanation": "Data lakes aggregate large volumes of data from multiple sources. This consolidation increases the risk of secondary uses that might exceed original purposes. Strong governance controls are needed to enforce purpose limitation and access restrictions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      118,
      117,
      103,
      126,
      105
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 113,
    "question": "Which of the following best supports the enforcement of data use limitation?",
    "choice_a": "Data classification labels",
    "choice_b": "Larger data retention windows",
    "choice_c": "Role-based access controls aligned to purpose",
    "choice_d": "Expanded analytics tools",
    "correct_answer": "C",
    "explanation": "Access controls tied to job roles and approved purposes help ensure that users can only access data necessary for authorized activities. This operationalizes use limitation and reduces the risk of unauthorized secondary use.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      121,
      103,
      111,
      113
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 114,
    "question": "Which technique reduces identifiability by combining records into groups?",
    "choice_a": "Tokenization",
    "choice_b": "Encryption",
    "choice_c": "Hashing",
    "choice_d": "Aggregation",
    "correct_answer": "D",
    "explanation": "Aggregation groups data into summary values such as averages or totals, reducing individual identifiability. While tokenization and hashing transform data, aggregation specifically combines records to produce less granular information.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      118,
      122,
      126,
      121,
      119
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 115,
    "question": "A data inventory and data flow diagram are complementary because they do which of the following?",
    "choice_a": "Define retention periods",
    "choice_b": "Replace classification controls",
    "choice_c": "Eliminate need for audits",
    "choice_d": "Provide static and dynamic views of data",
    "correct_answer": "D",
    "explanation": "A data inventory provides a static catalog of data assets, while a data flow diagram shows the dynamic movement and processing of data. Together, they provide a more complete understanding of the data lifecycle and support effective governance.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      109,
      105,
      103,
      107,
      106
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 116,
    "question": "Which action best improves data quality during collection?",
    "choice_a": "Collecting all available data fields",
    "choice_b": "Validating inputs at the point of entry",
    "choice_c": "Extending retention periods",
    "choice_d": "Encrypting data in transit",
    "correct_answer": "B",
    "explanation": "Input validation ensures that collected data meets expected formats and constraints. Early validation reduces errors and improves downstream data accuracy. Collecting excessive data increases risk and does not improve quality.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      104,
      116,
      120,
      103,
      111
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 117,
    "question": "A privacy professional reviewing AI training data should focus primarily on which of the following?",
    "choice_a": "CPU utilization",
    "choice_b": "Backup frequency",
    "choice_c": "Network throughput",
    "choice_d": "Dataset accuracy and representativeness",
    "correct_answer": "D",
    "explanation": "AI systems rely on the quality of training data. Inaccurate or biased datasets can produce harmful or unfair outcomes. Privacy professionals must evaluate whether training data is accurate, relevant, and appropriate for the intended use.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      118,
      116,
      110,
      103,
      119
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 118,
    "question": "An organization aggregates customer transaction data for analytics. Which control best reduces privacy risk while preserving analytical value?",
    "choice_a": "Encrypting the aggregated dataset",
    "choice_b": "Removing all classification labels",
    "choice_c": "Applying minimum group size thresholds before aggregation",
    "choice_d": "Extending data retention periods",
    "correct_answer": "C",
    "explanation": "Minimum group size thresholds ensure that aggregated results represent sufficiently large populations, reducing the likelihood that individual data points can be inferred from small groups. This technique preserves analytical usefulness while reducing privacy risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      122,
      126,
      119,
      111
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 119,
    "question": "Which control best aligns analytics initiatives with data use limitation principles?",
    "choice_a": "Expanding data lake ingestion policies",
    "choice_b": "Requiring purpose-based approval for new analytics use cases",
    "choice_c": "Increasing storage capacity",
    "choice_d": "Reducing logging requirements",
    "correct_answer": "B",
    "explanation": "Analytics platforms often encourage the reuse of existing data. Purpose-based approval ensures that new analytics activities are evaluated against original collection purposes and legal bases. This governance control prevents unauthorized secondary use and supports compliance with use limitation requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      103,
      118,
      109,
      108
    ],
    "source": "363803_Ch05"
  },
  {
    "id": 120,
    "question": "An organization implements a policy requiring business units to justify each data element collected in customer forms. Which principle is being applied?",
    "choice_a": "Data classification",
    "choice_b": "Data normalization",
    "choice_c": "Data anonymization",
    "choice_d": "Data minimization",
    "correct_answer": "D",
    "explanation": "Data minimization requires organizations to collect only the data that is necessary for clearly defined purposes. Requiring justification for each data element forces business units to evaluate whether the information is actually needed. This reduces unnecessary collection, lowers privacy risk, and decreases the volume of data that must later be secured, retained, and potentially destroyed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      120,
      104,
      103,
      127
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 121,
    "question": "Which of the following best distinguishes data disclosure from data transfer?",
    "choice_a": "Disclosure involves encryption; transfer does not",
    "choice_b": "Disclosure makes data accessible, while transfer moves custody or control",
    "choice_c": "Transfer is internal only; disclosure is external only",
    "choice_d": "Disclosure requires consent; transfer does not",
    "correct_answer": "B",
    "explanation": "Data disclosure typically means making information available to another party, such as allowing viewing or limited use, without necessarily transferring ownership or control. Data transfer, by contrast, involves moving data between entities or jurisdictions, often changing custody, legal responsibility, or regulatory obligations. Understanding this distinction helps organizations apply appropriate governance and compliance controls.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      103,
      109,
      107,
      111
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 122,
    "question": "A company keeps customer transaction data indefinitely “just in case” it might be useful. Which risk is most directly introduced?",
    "choice_a": "Reduced system availability",
    "choice_b": "Lower data accuracy",
    "choice_c": "Increased legal liability due to excessive retention",
    "choice_d": "Increased authentication complexity",
    "correct_answer": "C",
    "explanation": "Retaining data longer than necessary increases regulatory, legal, and breach exposure. Many privacy frameworks require organizations to retain personal data only for defined purposes and timeframes. Excessive retention expands the amount of data subject to discovery, increases the impact of a breach, and contradicts the principles of data minimization and retention limitation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      117,
      120,
      103
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 123,
    "question": "Which activity is most appropriate when defining data retention requirements?",
    "choice_a": "Aligning retention periods with legal and business obligations",
    "choice_b": "Reviewing employee performance metrics",
    "choice_c": "Encrypting archived backups",
    "choice_d": "Implementing data classification labels",
    "correct_answer": "A",
    "explanation": "Retention schedules should be developed with consideration of regulatory mandates, contractual requirements, litigation hold obligations, and operational needs. By aligning retention periods with these factors, organizations avoid premature deletion and unnecessary long-term storage of sensitive information. This balance supports compliance and reduces risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      111,
      103,
      105
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 124,
    "question": "An organization moves historical data from production systems to lower-cost storage but still requires occasional access. This is best described as which of the following?",
    "choice_a": "Data destruction",
    "choice_b": "Data disclosure",
    "choice_c": "Data minimization",
    "choice_d": "Data archiving",
    "correct_answer": "D",
    "explanation": "Data archiving involves relocating inactive or infrequently used data to long-term storage while maintaining the ability to retrieve it when needed. Archiving reduces operational system load and storage costs but requires maintaining appropriate security controls, integrity protections, and retention policies for the archived information.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      128,
      127,
      121,
      103,
      111
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 125,
    "question": "Which control most directly supports secure data transfer between organizations?",
    "choice_a": "Data deduplication",
    "choice_b": "Data normalization",
    "choice_c": "Encryption in transit",
    "choice_d": "Data compression",
    "correct_answer": "C",
    "explanation": "Encryption in transit protects data as it moves between systems or organizations by preventing interception or unauthorized disclosure. This control is especially important during transfers across networks, including public networks, where data might otherwise be exposed. Encryption helps ensure confidentiality and supports regulatory requirements for secure data movement.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      113,
      111,
      115
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 126,
    "question": "A privacy program requires the removal of identifiers once they are no longer needed for operational purposes. This practice primarily supports which of the following?",
    "choice_a": "Data minimization",
    "choice_b": "Data classification",
    "choice_c": "Data masking",
    "choice_d": "Data migration",
    "correct_answer": "A",
    "explanation": "Removing identifiers reduces the sensitivity of stored data and limits the risk of unauthorized disclosure. This practice reflects minimization by retaining only the information necessary for ongoing operations. It also reduces compliance obligations and lowers the impact of potential breaches.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      119,
      120,
      127,
      128,
      129
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 127,
    "question": "Which factor(s) should most strongly influence the selection of a data destruction method?",
    "choice_a": "Storage cost",
    "choice_b": "Vendor preference",
    "choice_c": "Backup frequency",
    "choice_d": "Media type and data sensitivity",
    "correct_answer": "D",
    "explanation": "Different storage media require different destruction approaches. For example, overwriting can be sufficient for magnetic media but not for solid-state drives. The sensitivity of the data also affects the level of assurance required. Selecting methods based on these factors ensures that data is rendered unrecoverable.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      129,
      111,
      110,
      127,
      103
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 128,
    "question": "An organization shares customer data with a service provider that processes it on behalf of the organization. This is an example of which of the following?",
    "choice_a": "Data migration",
    "choice_b": "Data destruction",
    "choice_c": "Data disclosure and transfer",
    "choice_d": "Data classification",
    "correct_answer": "C",
    "explanation": "Providing data to a service provider typically involves both disclosure and transfer. The receiving organization gains access to the data, and custody can shift for processing purposes. This scenario requires contractual controls, data protection measures, and compliance with applicable privacy regulations.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      123,
      109,
      103,
      121,
      117
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 129,
    "question": "Which of the following is the primary purpose of a retention schedule?",
    "choice_a": "Define system uptime targets",
    "choice_b": "Specify how long different data types should be kept",
    "choice_c": "Determine encryption algorithms",
    "choice_d": "Identify data owners",
    "correct_answer": "B",
    "explanation": "A retention schedule establishes the duration for which specific categories of data must be stored. It also identifies when data should be archived or destroyed. This structured approach ensures consistent application of retention requirements across the organization.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      127,
      128,
      129,
      111,
      103
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 130,
    "question": "Which scenario best demonstrates data minimization during processing?",
    "choice_a": "Encrypting all stored data",
    "choice_b": "Replicating data across regions",
    "choice_c": "Aggregating data to remove individual identifiers",
    "choice_d": "Archiving inactive accounts",
    "correct_answer": "C",
    "explanation": "Aggregation reduces the level of detail associated with individual data subjects. By using summarized or grouped data, organizations limit identifiability and reduce privacy risk. This aligns with minimization principles during data processing and analytics.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      118,
      119,
      126,
      121,
      117
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 131,
    "question": "What is the primary risk of archiving data without applying security controls?",
    "choice_a": "Reduced processing speed",
    "choice_b": "Increased storage costs",
    "choice_c": "Data duplication errors",
    "choice_d": "Unauthorized access to long-term stored data",
    "correct_answer": "D",
    "explanation": "Archived data often contains sensitive or regulated information and might remain stored for extended periods. Without proper access controls, encryption, and monitoring, archived data can become a source of overlooked exposure. Attackers frequently target archival storage because it might have weaker protections.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      121,
      128,
      125,
      127,
      115
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 132,
    "question": "Which of the following best describes cryptographic erasure?",
    "choice_a": "Destroying encryption keys to render data unreadable",
    "choice_b": "Physically shredding storage media",
    "choice_c": "Overwriting data multiple times",
    "choice_d": "Compressing archived data",
    "correct_answer": "A",
    "explanation": "Cryptographic erasure involves deleting or destroying encryption keys associated with encrypted data. Without the keys, the data cannot be decrypted and is effectively unrecoverable. This method is efficient for large volumes of encrypted data and is commonly used in cloud and storage environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      127,
      111,
      128,
      121
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 133,
    "question": "An organization moves customer records from an old CRM system to a new one within the same company. This is an example of which of the following?",
    "choice_a": "Data disclosure",
    "choice_b": "Data destruction",
    "choice_c": "Data archival",
    "choice_d": "Data migration",
    "correct_answer": "D",
    "explanation": "Data migration refers to transferring data between systems, typically during upgrades, consolidation, or modernization efforts. The data remains within the organization, and the purpose is continuity of operations. Migration requires careful planning to preserve integrity, accuracy, and security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      124,
      109,
      103,
      107,
      111
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 134,
    "question": "Which control assures that data destruction activities were completed properly?",
    "choice_a": "Data classification labels",
    "choice_b": "Data mapping diagram",
    "choice_c": "Certificate of destruction",
    "choice_d": "Encryption audit log",
    "correct_answer": "C",
    "explanation": "A certificate of destruction documents that data or media have been securely destroyed using an approved method. This documentation supports audits, demonstrates compliance with retention requirements, and provides accountability for destruction activities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      127,
      111,
      103,
      128
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 135,
    "question": "A company retains logs for regulatory compliance but deletes unnecessary fields within those logs. This approach reflects which of the following?",
    "choice_a": "Data minimization",
    "choice_b": "Data disclosure",
    "choice_c": "Data migration",
    "choice_d": "Data masking",
    "correct_answer": "A",
    "explanation": "Removing unnecessary fields limits the amount of personal or sensitive information retained. This allows the organization to meet compliance obligations while reducing privacy risk. Minimization can occur even when data must be retained for regulatory purposes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      120,
      121,
      127,
      128
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 136,
    "question": "Which is the most appropriate reason to archive data rather than delete it?",
    "choice_a": "Improve system performance only",
    "choice_b": "Reduce encryption overhead",
    "choice_c": "Maintain data for legal or historical requirements",
    "choice_d": "Simplify access control management",
    "correct_answer": "C",
    "explanation": "Organizations often must retain certain records for statutory, contractual, or historical reasons. Archiving allows them to remove data from active systems while preserving it for required use. This approach balances operational efficiency with compliance obligations.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      128,
      127,
      121,
      103,
      125
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 137,
    "question": "An organization transfers personal data to another country. Which consideration is most important?",
    "choice_a": "Data integrity",
    "choice_b": "Backup frequency",
    "choice_c": "Data compression efficiency",
    "choice_d": "Jurisdictional and regulatory requirements",
    "correct_answer": "D",
    "explanation": "Privacy laws and regulations can restrict cross-border transfers. Organizations must evaluate whether appropriate safeguards, contractual clauses, or adequacy mechanisms are required. Failure to address jurisdictional requirements can result in regulatory violations.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      123,
      125,
      103,
      109,
      117
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 138,
    "question": "Which destruction method is most appropriate for decommissioned solid-state drives containing sensitive data?",
    "choice_a": "File deletion",
    "choice_b": "Formatting the drive",
    "choice_c": "Data compression",
    "choice_d": "Physical destruction or cryptographic erasure",
    "correct_answer": "D",
    "explanation": "Solid-state drives can retain data after traditional deletion or formatting due to wear-leveling mechanisms. Overwriting is often ineffective on solid-state drives. Physical destruction or cryptographic erasure provides higher assurance that data cannot be recovered. These methods are recommended for highly sensitive information.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      129,
      111,
      127,
      110,
      121
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 139,
    "question": "An organization shares anonymized analytics results with a partner without providing underlying data. This activity is best described as which of the following?",
    "choice_a": "Data transfer",
    "choice_b": "Data disclosure",
    "choice_c": "Data migration",
    "choice_d": "Data destruction",
    "correct_answer": "B",
    "explanation": "Providing derived or aggregated results constitutes disclosure because information is being shared. However, the underlying dataset is not transferred, and custody remains with the originating organization. This distinction affects contractual and governance requirements.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      123,
      118,
      117,
      109,
      103
    ],
    "source": "363803_Ch06"
  },
  {
    "id": 140,
    "question": "Which infrastructure characteristic most directly affects data residency and sovereignty requirements?",
    "choice_a": "Geographic location of data centers",
    "choice_b": "Load balancing configuration",
    "choice_c": "CPU utilization levels",
    "choice_d": "Application response time",
    "correct_answer": "A",
    "explanation": "Data residency and sovereignty requirements depend on where data is physically stored and processed. The geographic location of data centers determines which legal and regulatory regimes apply, making it a primary privacy consideration in infrastructure design.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      163,
      145,
      144
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 141,
    "question": "Which control is most effective in minimizing privacy risk on endpoint devices?",
    "choice_a": "Increasing device processing speed",
    "choice_b": "Installing additional applications",
    "choice_c": "Expanding storage capacity",
    "choice_d": "Enabling local data encryption",
    "correct_answer": "D",
    "explanation": "Local data encryption protects personal data stored on endpoint devices from unauthorized access, particularly in cases of device loss or theft. It is a foundational privacy and security control for endpoints.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      136,
      187,
      191,
      169,
      206
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 142,
    "question": "What is the primary privacy risk associated with unsegmented network connectivity?",
    "choice_a": "Reduced bandwidth utilization",
    "choice_b": "Increased hardware costs",
    "choice_c": "Unauthorized lateral data movement",
    "choice_d": "Improved system performance",
    "correct_answer": "C",
    "explanation": "Lack of network segmentation allows data and access to move laterally across systems without restriction, increasing the likelihood of unauthorized access to personal data and expanding the impact of a breach.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      186,
      139,
      138,
      174,
      173
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 143,
    "question": "In the systems development lifecycle (SDLC), when should privacy requirements be first defined?",
    "choice_a": "During deployment",
    "choice_b": "During testing",
    "choice_c": "During design",
    "choice_d": "During maintenance",
    "correct_answer": "C",
    "explanation": "Privacy requirements must be established during the design phase to ensure that systems are built with appropriate controls from the outset. Late-stage integration of privacy controls is less effective and more costly.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      144,
      146,
      145,
      142,
      159
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 144,
    "question": "Which API control best prevents excessive exposure of personal data?",
    "choice_a": "Implementing data filtering and field-level access",
    "choice_b": "Increasing API response time",
    "choice_c": "Returning full datasets by default",
    "choice_d": "Disabling logging",
    "correct_answer": "A",
    "explanation": "Data filtering and field-level access ensure that only necessary data elements are returned in API responses, supporting data minimization and reducing the risk of overexposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      207,
      174,
      196,
      169
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 145,
    "question": "Which cloud-native characteristic introduces additional privacy complexity?",
    "choice_a": "Distributed microservices processing",
    "choice_b": "Centralized architecture",
    "choice_c": "Static resource allocation",
    "choice_d": "Single application deployment",
    "correct_answer": "A",
    "explanation": "Microservices distribute processing across multiple components, increasing the number of data flows and interfaces. This creates additional complexity in enforcing consistent privacy controls across services.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      161,
      164,
      132,
      156,
      169
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 146,
    "question": "Which endpoint scenario presents the highest privacy risk?",
    "choice_a": "Centrally managed corporate laptop",
    "choice_b": "Unmanaged personal device accessing sensitive data",
    "choice_c": "Encrypted mobile device",
    "choice_d": "Virtual desktop infrastructure session",
    "correct_answer": "B",
    "explanation": "Unmanaged personal devices lack standardized controls, monitoring, and enforcement mechanisms, making them more susceptible to data leakage, malware, and unauthorized access to personal data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      138,
      136,
      137,
      200,
      169
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 147,
    "question": "What is the primary purpose of network encryption in privacy engineering?",
    "choice_a": "Protect data in transit from interception",
    "choice_b": "Improve transmission speed",
    "choice_c": "Reduce storage requirements",
    "choice_d": "Simplify application design",
    "correct_answer": "A",
    "explanation": "Encryption in transit ensures that data cannot be read or altered by unauthorized parties during transmission across networks, which is essential for protecting personal data flows.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      187,
      140,
      188,
      191,
      161
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 148,
    "question": "Which SDLC activity specifically identifies how personal data moves through a system?",
    "choice_a": "Data inventory",
    "choice_b": "Data flow mapping",
    "choice_c": "Performance tuning",
    "choice_d": "Input validation",
    "correct_answer": "B",
    "explanation": "Data flow mapping identifies how personal data is collected, processed, stored, and transmitted within a system, enabling identification of privacy risks and control points.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      146,
      144,
      155,
      169,
      134
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 149,
    "question": "What is the primary privacy concern with poorly secured APIs?",
    "choice_a": "Reduced system uptime",
    "choice_b": "Increased latency",
    "choice_c": "Unauthorized data access and leakage",
    "choice_d": "Higher infrastructure cost",
    "correct_answer": "C",
    "explanation": "APIs expose system functionality and data. Without proper authentication, authorization, and validation, they can become entry points for unauthorized access to personal data, resulting in data loss and potential harm.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      161,
      176,
      159,
      173,
      175
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 150,
    "question": "Which infrastructure model provides the least direct control over underlying hardware?",
    "choice_a": "On-premises infrastructure",
    "choice_b": "Public cloud",
    "choice_c": "Private cloud",
    "choice_d": "Dedicated hosting",
    "correct_answer": "B",
    "explanation": "In public cloud environments, the cloud provider manages the underlying hardware and infrastructure, reducing the organization’s direct control and requiring reliance on shared responsibility models.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      164,
      162,
      132
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 151,
    "question": "Which endpoint control best supports data minimization?",
    "choice_a": "Limiting local data caching",
    "choice_b": "Expanding local storage",
    "choice_c": "Increasing application permissions",
    "choice_d": "Disabling updates",
    "correct_answer": "A",
    "explanation": "Limiting local data caching reduces the amount of personal data stored on devices, thereby minimizing exposure in case of compromise or loss.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      136,
      137,
      138,
      169,
      207
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 152,
    "question": "What is the primary function of an API gateway in a microservices architecture?",
    "choice_a": "Store application data",
    "choice_b": "Replace backend services",
    "choice_c": "Manage user authentication centrally",
    "choice_d": "Eliminate network traffic",
    "correct_answer": "C",
    "explanation": "An API gateway acts as a centralized entry point for requests, often enforcing authentication, authorization, and routing. It helps control access to services and reduces direct exposure of internal components.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      161,
      176,
      173,
      159,
      186
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 153,
    "question": "Which connectivity-related practice best supports privacy when transmitting personal data between systems?",
    "choice_a": "Sending data in plain text over internal networks",
    "choice_b": "Using encrypted communication protocols such as TLS",
    "choice_c": "Compressing data before transmission",
    "choice_d": "Increasing packet size to reduce overhead",
    "correct_answer": "B",
    "explanation": "Encrypted communication protocols such as TLS protect personal data in transit by preventing interception and unauthorized disclosure during transmission. Connectivity between systems often crosses internal and external networks, and encryption ensures confidentiality and integrity regardless of the underlying transport. This aligns with privacy engineering principles by safeguarding personal data as it moves across components of the technology stack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      140,
      161,
      185,
      184
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 154,
    "question": "Which SDLC practice ensures that privacy controls are functioning as intended before release?",
    "choice_a": "Code documentation",
    "choice_b": "Configuration management",
    "choice_c": "Privacy testing and validation",
    "choice_d": "Version tracking",
    "correct_answer": "C",
    "explanation": "Privacy testing verifies that implemented controls, such as data minimization, consent enforcement, and retention rules, operate correctly before deployment.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      148,
      149,
      144,
      169,
      196
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 155,
    "question": "In a cloud-native environment, what is the primary privacy risk associated with misconfigured identity and access management (IAM)?",
    "choice_a": "Reduced system scalability",
    "choice_b": "Unauthorized access to distributed services and data",
    "choice_c": "Increased processing latency",
    "choice_d": "Higher storage costs",
    "correct_answer": "B",
    "explanation": "Misconfigured identity and access management can result in excessive permissions across multiple services, enabling unauthorized access to personal data in a distributed environment where services interact dynamically.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      173,
      161,
      174,
      163,
      180
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 156,
    "question": "Which scenario best illustrates a privacy-by-design principle in SDLC?",
    "choice_a": "Adding encryption after a breach",
    "choice_b": "Disabling logging to improve performance",
    "choice_c": "Increasing system complexity",
    "choice_d": "Implementing access controls during development",
    "correct_answer": "D",
    "explanation": "Privacy by design requires integrating privacy controls early in development. Implementing access controls during development ensures that privacy protections are built into the system from the outset.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      142,
      169,
      146,
      159
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 157,
    "question": "Which device category typically introduces the most challenges for privacy engineering due to limited control and visibility?",
    "choice_a": "Enterprise-managed servers",
    "choice_b": "Virtual machines in a data center",
    "choice_c": "Internet of Things (IoT) devices",
    "choice_d": "Cloud-based storage systems",
    "correct_answer": "C",
    "explanation": "IoT devices often lack standardized security controls, have limited update mechanisms, and might continuously collect sensitive data. Their distributed nature and limited manageability create significant privacy risks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      139,
      200,
      136,
      138,
      186
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 158,
    "question": "Which architectural pattern most complicates consistent enforcement of privacy controls across services?",
    "choice_a": "Monolithic architecture",
    "choice_b": "Microservices architecture",
    "choice_c": "Single-tier application",
    "choice_d": "Standalone application",
    "correct_answer": "B",
    "explanation": "Microservices architectures distribute functionality across multiple independent services, each with its own interfaces and data handling processes. This increases the complexity of maintaining consistent privacy controls, such as access management, logging, and data minimization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      169,
      173,
      186,
      163
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 159,
    "question": "Which of the following is the best example of a basic privacy control?",
    "choice_a": "Encrypting data at rest",
    "choice_b": "Increasing server capacity",
    "choice_c": "Adding additional processors",
    "choice_d": "Expanding network bandwidth",
    "correct_answer": "A",
    "explanation": "Encrypting data at rest is a fundamental privacy and security control that protects stored personal data from unauthorized access, especially in cases of system compromise or physical theft.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      207,
      191,
      170,
      144
    ],
    "source": "363803_Ch07"
  },
  {
    "id": 160,
    "question": "Which asset management activity most directly supports privacy engineering objectives?",
    "choice_a": "Tracking software license costs",
    "choice_b": "Maintaining an inventory of systems that store personal data",
    "choice_c": "Monitoring CPU utilization",
    "choice_d": "Measuring application performance",
    "correct_answer": "B",
    "explanation": "Maintaining an inventory of systems that store personal data allows organizations to identify where personal information resides across infrastructure, applications, and repositories. This visibility enables privacy engineers to apply appropriate safeguards such as access restrictions, encryption, retention policies, and monitoring. Without an accurate inventory, personal data might exist in unknown locations, increasing the risk of unauthorized exposure, inconsistent control implementation, and non-compliance with regulatory obligations.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      166,
      167,
      165,
      169,
      172
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 161,
    "question": "Which IAM principle is most effective in reducing unnecessary exposure to personal data?",
    "choice_a": "Role-based access control",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Multi-factor authentication",
    "correct_answer": "C",
    "explanation": "The principle of least privilege ensures that users receive only the access necessary to perform their assigned duties. By limiting permissions to the minimum required, organizations reduce the number of individuals who can view or manipulate personal data. This directly lowers the risk of accidental disclosure, misuse, or malicious access. Least privilege is particularly important in privacy engineering because excessive access often leads to unnecessary data exposure across systems and environments.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      174,
      173,
      176,
      179,
      180
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 162,
    "question": "What is the primary privacy benefit of timely patch management?",
    "choice_a": "Reducing exploitable vulnerabilities",
    "choice_b": "Improving application performance",
    "choice_c": "Lowering operational costs",
    "choice_d": "Enhancing audit reporting",
    "correct_answer": "A",
    "explanation": "Timely patch management addresses known vulnerabilities in operating systems, applications, and firmware. Attackers often exploit unpatched systems to gain unauthorized access to sensitive information, including personal data. By promptly applying security patches, organizations reduce the likelihood that vulnerabilities can be leveraged for data exfiltration or unauthorized processing. This directly supports privacy objectives by maintaining confidentiality and reducing the attack surface associated with systems that handle personal data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      182,
      175,
      169,
      136,
      159
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 163,
    "question": "Which protocol is specifically designed to protect data in transit over the web?",
    "choice_a": "SSL",
    "choice_b": "HTTP",
    "choice_c": "TLS",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "Transport Layer Security (TLS) encrypts data transmitted between clients and servers, ensuring confidentiality and integrity during communication. When personal data is transmitted over networks, particularly the Internet, it is vulnerable to interception or modification. TLS prevents eavesdropping and tampering by encrypting the communication channel and validating endpoints. This protection is essential for privacy engineering, as many privacy risks arise from insecure data transmission between systems or users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      184,
      203,
      207,
      161
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 164,
    "question": "Which statement best describes hashing in a privacy context?",
    "choice_a": "It encrypts data using a reversible key",
    "choice_b": "It compresses data for storage efficiency",
    "choice_c": "It masks data for display only",
    "choice_d": "It transforms data into a non-reversible value",
    "correct_answer": "D",
    "explanation": "Hashing converts data into a fixed-length value using a one-way mathematical function. Unlike encryption, hashing is not reversible, meaning the original data cannot be reconstructed from the hash value. This property is useful in privacy engineering for protecting sensitive elements such as passwords or verification tokens. Even if a system is compromised, hashed values do not directly reveal the original personal data, reducing the risk of exposure.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      190,
      187,
      206,
      207,
      159
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 165,
    "question": "Why are monitoring and logging important for privacy engineering?",
    "choice_a": "They detect unauthorized access to personal data",
    "choice_b": "They reduce storage requirements",
    "choice_c": "They automate system backups",
    "choice_d": "They improve network bandwidth",
    "correct_answer": "A",
    "explanation": "Monitoring and logging provide visibility into who accessed personal data, when access occurred, and what actions were performed. This information enables detection of suspicious or unauthorized activity, supports incident response, and helps organizations meet accountability requirements. Effective logging also supports forensic analysis after a privacy incident, allowing organizations to determine the scope of exposure and take corrective action. Without monitoring, unauthorized access to personal data can go undetected.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      193,
      181,
      202,
      203,
      135
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 166,
    "question": "Which asset management practice best supports data minimization?",
    "choice_a": "Increasing storage capacity",
    "choice_b": "Implementing multi-factor authentication",
    "choice_c": "Identifying unused systems containing personal data",
    "choice_d": "Enabling network segmentation",
    "correct_answer": "C",
    "explanation": "Identifying unused systems containing personal data allows organizations to eliminate unnecessary data storage locations. Decommissioning or sanitizing these assets reduces the volume of retained personal information and limits exposure. Data minimization is a core privacy principle, and asset management supports it by ensuring that personal data is only stored where necessary. Removing redundant or obsolete systems reduces both operational complexity and privacy risk.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      154,
      165,
      132,
      150
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 167,
    "question": "Which IAM control most directly prevents unauthorized access when credentials are compromised?",
    "choice_a": "Multi-factor authentication",
    "choice_b": "Single sign-on",
    "choice_c": "Role-based access control",
    "choice_d": "Privileged access review",
    "correct_answer": "A",
    "explanation": "Multi-factor authentication (MFA) requires users to provide multiple forms of verification, such as something they know, have, or are. Even if an attacker obtains a user ID and password, the attacker is unlikely to possess the additional factor required for access. This significantly reduces the likelihood of unauthorized entry into systems containing personal data. MFA is therefore a critical privacy-related security control, especially for privileged accounts and systems that process sensitive information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      176,
      179,
      173,
      181
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 168,
    "question": "What is the primary objective of system hardening in privacy engineering?",
    "choice_a": "Removing unnecessary services and configurations",
    "choice_b": "Increasing application availability",
    "choice_c": "Expanding logging capabilities",
    "choice_d": "Encrypting database backups",
    "correct_answer": "A",
    "explanation": "System hardening involves turning off unused services, removing default accounts, enforcing secure configurations, and limiting functionality to only what is necessary. By reducing the number of potential entry points, organizations reduce the attack surface that could be exploited to access personal data. Hardening complements patch management and helps prevent unauthorized access or system compromise that could lead to privacy violations.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      183,
      169,
      175,
      182,
      159
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 169,
    "question": "Which transport control best protects personal data transmitted between microservices?",
    "choice_a": "Plain HTTP",
    "choice_b": "FTP transfer",
    "choice_c": "Telnet session",
    "choice_d": "TLS-secured API communication",
    "correct_answer": "D",
    "explanation": "Microservices architectures often involve frequent data exchanges between components. Using TLS-secured API communication ensures that these exchanges are encrypted and authenticated. Without encryption, personal data transmitted internally could be intercepted or manipulated. TLS provides confidentiality and integrity protections, making it an essential control for protecting personal data moving within distributed systems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      161,
      187,
      159,
      184,
      169
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 170,
    "question": "Encryption primarily supports which privacy objective?",
    "choice_a": "Availability",
    "choice_b": "Accountability",
    "choice_c": "Auditability",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "Encryption protects confidentiality by transforming readable data into ciphertext that can only be accessed using a decryption key. This ensures that even if storage media, backups, or network transmissions are compromised, personal data remains protected. Encryption is widely used for data at rest, in transit, and sometimes in use, making it one of the most fundamental controls for safeguarding personal information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      206,
      191,
      188,
      169
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 171,
    "question": "Which logging practice best supports privacy incident investigations?",
    "choice_a": "Logging only system errors",
    "choice_b": "Logging access to personal data repositories",
    "choice_c": "Logging CPU usage",
    "choice_d": "Logging disk capacity thresholds",
    "correct_answer": "B",
    "explanation": "Logging access to personal data repositories provides a record of who accessed sensitive information and what actions were performed. This information is critical for identifying unauthorized access, determining the scope of exposure, and supporting forensic analysis. Logs also provide evidence for regulatory reporting and compliance verification. Without such logging, organizations might be unable to determine whether personal data was improperly accessed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      176,
      173,
      179,
      174
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 172,
    "question": "Which asset attribute is most important for applying privacy controls?",
    "choice_a": "Hardware vendor",
    "choice_b": "Physical location",
    "choice_c": "Data classification",
    "choice_d": "Warranty expiration date",
    "correct_answer": "C",
    "explanation": "Data classification identifies the sensitivity level of information stored or processed by an asset. Assets containing personal data require stronger controls such as encryption, restricted access, and enhanced monitoring. By classifying data, organizations can apply appropriate safeguards based on risk. Without classification, privacy controls can be inconsistently applied, leaving sensitive data insufficiently protected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      167,
      169,
      144,
      172,
      168
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 173,
    "question": "Which IAM activity supports ongoing privacy compliance?",
    "choice_a": "Periodic access reviews",
    "choice_b": "Password length enforcement",
    "choice_c": "Network segmentation",
    "choice_d": "Password complexity enforcement",
    "correct_answer": "A",
    "explanation": "Periodic access reviews ensure that users continue to require access to personal data as roles change. Over time, individuals can accumulate permissions that are no longer necessary. Regular reviews identify and remove excessive access, reducing privacy risk and supporting least privilege. This process also helps organizations demonstrate compliance with privacy regulations that require access governance.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      180,
      174,
      173,
      181,
      176
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 174,
    "question": "Why should organizations encrypt personal data backups?",
    "choice_a": "To improve backup speed",
    "choice_b": "To reduce storage costs",
    "choice_c": "To simplify restoration",
    "choice_d": "To protect data if backup media are compromised",
    "correct_answer": "D",
    "explanation": "Backup media can be stored offsite, transported, or handled by third parties, increasing the risk of unauthorized access. Encrypting backups ensures that personal data remains unreadable even if media are lost, stolen, or improperly accessed. This protects confidentiality and aligns with privacy requirements for safeguarding stored personal information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      191,
      169,
      144,
      167
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 175,
    "question": "Which monitoring capability best supports the detection of insider misuse of personal data?",
    "choice_a": "Network bandwidth monitoring",
    "choice_b": "User activity monitoring on sensitive systems",
    "choice_c": "Hardware temperature monitoring",
    "choice_d": "Patch compliance reporting",
    "correct_answer": "B",
    "explanation": "User activity monitoring tracks actions performed by individuals on systems containing personal data. This includes access patterns, data exports, and unusual behavior. Such monitoring can detect insider threats, such as employees accessing data outside their job responsibilities. Detecting these behaviors early helps prevent unauthorized disclosure and supports incident response.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      202,
      193,
      136,
      180
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 176,
    "question": "Which control ensures that personal data transmitted between organizations is protected from interception?",
    "choice_a": "Data retention policy",
    "choice_b": "Asset lifecycle management",
    "choice_c": "Access recertification",
    "choice_d": "Secure transport protocol",
    "correct_answer": "D",
    "explanation": "Secure transport protocols such as TLS encrypt communications between organizations. When personal data is transmitted externally, it is particularly vulnerable to interception. Encryption ensures confidentiality and integrity, preventing unauthorized parties from accessing or altering data during transmission.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      203,
      187,
      188,
      140,
      161
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 177,
    "question": "Which hashing use case most directly supports privacy engineering?",
    "choice_a": "Encrypting database connections",
    "choice_b": "Protecting stored passwords",
    "choice_c": "Securing network routing",
    "choice_d": "Compressing log files",
    "correct_answer": "B",
    "explanation": "Hashing stored passwords ensures that actual values are not retained in plaintext. If a database is compromised, attackers obtain hashed values rather than usable credentials. Strong hashing algorithms with salting further reduce the likelihood of recovery. This approach protects user credentials and limits privacy exposure.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      177,
      187,
      207,
      190,
      179
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 178,
    "question": "An organization maintains strong encryption but does not manage cryptographic keys properly. What is the greatest privacy risk?",
    "choice_a": "Increased storage consumption",
    "choice_b": "Unauthorized data access due to key exposure",
    "choice_c": "Reduced application performance",
    "choice_d": "Incomplete logging records",
    "correct_answer": "B",
    "explanation": "Encryption is only effective when keys are securely generated, stored, and managed. Poor key management, such as storing keys alongside encrypted data or failing to rotate keys, can allow unauthorized individuals to decrypt personal data. This undermines confidentiality and creates significant privacy risk. Effective privacy engineering requires strong key lifecycle management.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      191,
      192,
      187,
      188,
      189
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 179,
    "question": "A privacy engineer wants to detect unauthorized bulk downloads of personal data. Which control is most appropriate?",
    "choice_a": "Asset inventory update",
    "choice_b": "Patch deployment",
    "choice_c": "Behavioral monitoring and logging",
    "choice_d": "Password complexity enforcement",
    "correct_answer": "C",
    "explanation": "Behavioral monitoring analyzes patterns of system usage and data access. Detecting unusually large downloads or abnormal access patterns can indicate potential data exfiltration. Combined with logging, this control enables organizations to identify and respond to privacy incidents involving unauthorized transfer of personal data.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      193,
      181,
      203,
      138,
      169
    ],
    "source": "363803_Ch08"
  },
  {
    "id": 180,
    "question": "Which of the following best describes consent tagging?",
    "choice_a": "Encrypting personal data fields before storage",
    "choice_b": "Removing identifiers from datasets",
    "choice_c": "Logging user authentication events",
    "choice_d": "Associating metadata with data to record permitted uses and restrictions",
    "correct_answer": "D",
    "explanation": "Consent tagging involves attaching metadata to data elements that reflects the data subject’s consent preferences, lawful basis, and permitted uses. This enables systems to enforce processing restrictions automatically and ensures that downstream uses of data remain consistent with the individual’s consent.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      196
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 181,
    "question": "A cookie banner that allows users to accept analytics cookies but reject advertising cookies demonstrates which of the following?",
    "choice_a": "Granular consent management",
    "choice_b": "Data masking",
    "choice_c": "Tokenization",
    "choice_d": "Differential privacy",
    "correct_answer": "A",
    "explanation": "Granular consent management allows users to selectively permit different categories of tracking technologies. This supports privacy regulations that require specific and informed consent rather than blanket acceptance. The banner enforces user preferences at a category level, aligning data collection with declared purposes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      204,
      198,
      197
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 182,
    "question": "Which technique replaces identifiers with reversible substitutes that require a separate lookup table?",
    "choice_a": "Tokenization",
    "choice_b": "Anonymization",
    "choice_c": "Hashing with no salt",
    "choice_d": "Aggregation",
    "correct_answer": "A",
    "explanation": "Tokenization replaces direct identifiers with tokens or pseudonyms while maintaining the ability to re-identify individuals using additional information stored separately. This reduces the risk of exposure but does not eliminate identifiability, so the data remains personal data under most privacy regulations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 183,
    "question": "Which of the following is the primary risk associated with anonymized datasets?",
    "choice_a": "Encryption failure",
    "choice_b": "Data retention violations",
    "choice_c": "Lack of access controls",
    "choice_d": "Re-identification through linkage attacks",
    "correct_answer": "D",
    "explanation": "Even when identifiers are removed, anonymized datasets can be re-identified by correlating them with other datasets. This is known as a linkage or re-identification attack. Proper anonymization requires assessing this risk and applying techniques such as aggregation, suppression, or noise addition.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      206,
      207,
      208,
      144,
      169
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 184,
    "question": "Which of the following is considered a privacy-enhancing technology (PET)?",
    "choice_a": "Network segmentation",
    "choice_b": "Differential privacy",
    "choice_c": "Patch management",
    "choice_d": "Multi-factor authentication",
    "correct_answer": "B",
    "explanation": "Differential privacy is a PET that introduces statistical noise into datasets or query outputs to prevent the identification of individuals while still allowing meaningful analysis. It is specifically designed to balance data utility with privacy protection.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      207,
      206,
      208
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 185,
    "question": "Consent tagging is most useful in which scenario?",
    "choice_a": "Enforcing user-specific data processing restrictions across systems",
    "choice_b": "Limiting administrator privileges",
    "choice_c": "Encrypting backups",
    "choice_d": "Detecting malware",
    "correct_answer": "A",
    "explanation": "Consent tagging allows organizations to propagate user consent preferences alongside data. This ensures that downstream systems honor permitted purposes and prevents unauthorized processing that conflicts with original consent.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      161,
      173,
      163,
      134
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 186,
    "question": "Which tracking technology is most commonly used to monitor user behavior across websites?",
    "choice_a": "Third-party cookies",
    "choice_b": "Session tokens",
    "choice_c": "TLS certificates",
    "choice_d": "DNSSEC",
    "correct_answer": "A",
    "explanation": "Third-party cookies are placed by domains other than the one the user is visiting. They enable cross-site tracking and profiling, leading to increased regulatory scrutiny and browser restrictions.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      198,
      197,
      204,
      203,
      200
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 187,
    "question": "Which anonymization technique reduces risk by grouping individuals into broader categories?",
    "choice_a": "Tokenization",
    "choice_b": "Encryption",
    "choice_c": "Generalization",
    "choice_d": "Hash chaining",
    "correct_answer": "C",
    "explanation": "Generalization reduces data precision, for example, by replacing exact ages with age ranges. This increases the size of anonymity sets and reduces the likelihood of identifying individuals.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      206,
      207
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 188,
    "question": "Federated learning improves privacy by doing which of the following?",
    "choice_a": "Centralizing all training data",
    "choice_b": "Encrypting cookies",
    "choice_c": "Training models locally and sharing model updates instead of raw data",
    "choice_d": "Removing audit logs",
    "correct_answer": "C",
    "explanation": "Federated learning keeps data on local devices and shares only model parameters or gradients. This reduces exposure of raw personal data and supports privacy-preserving machine learning workflows.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      207,
      208,
      206,
      196,
      161
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 189,
    "question": "Which control ensures that tracking technologies operate only after user consent?",
    "choice_a": "Data retention policy",
    "choice_b": "Access control list",
    "choice_c": "Key escrow",
    "choice_d": "Consent enforcement mechanism",
    "correct_answer": "D",
    "explanation": "Consent enforcement mechanisms block or enable tracking technologies based on user selections. This is typically implemented through consent management platforms that control script execution.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      204,
      197,
      169,
      144
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 190,
    "question": "Which scenario represents pseudonymization rather than anonymization?",
    "choice_a": "Removing all identifying attributes permanently",
    "choice_b": "Aggregating data into statistical summaries",
    "choice_c": "Deleting records entirely",
    "choice_d": "Replacing names with unique identifiers stored separately",
    "correct_answer": "D",
    "explanation": "Pseudonymization retains the ability to re-identify individuals using a separate mapping. Tokenization is a form of pseudonymization. This distinguishes it from anonymization, where re-identification should not be reasonably possible.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      206,
      208,
      207
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 191,
    "question": "Which PET allows computations on encrypted data without decrypting it?",
    "choice_a": "Tokenization",
    "choice_b": "Homomorphic encryption",
    "choice_c": "Hashing",
    "choice_d": "Data masking",
    "correct_answer": "B",
    "explanation": "Homomorphic encryption enables the processing of encrypted data while preserving confidentiality. This supports privacy-preserving analytics without exposing underlying personal data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      187,
      206,
      191,
      192
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 192,
    "question": "A model inversion attack attempts to do which of the following?",
    "choice_a": "Corrupt training data",
    "choice_b": "Deny service to ML systems",
    "choice_c": "Extract sensitive information from trained models",
    "choice_d": "Modify consent records",
    "correct_answer": "C",
    "explanation": "Model inversion attacks exploit trained models to infer information about individuals in the training dataset. This is a key privacy risk associated with machine learning systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      208,
      207,
      206,
      169,
      196
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 193,
    "question": "Which control best mitigates excessive data collection by tracking technologies?",
    "choice_a": "Data minimization configuration",
    "choice_b": "Backup rotation",
    "choice_c": "Patch management",
    "choice_d": "Network load balancing",
    "correct_answer": "A",
    "explanation": "Configuring tracking technologies to collect only necessary data supports data minimization principles and reduces privacy risk. This includes limiting fields, retention periods, and tracking scope.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      198,
      204,
      207,
      196,
      139
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 194,
    "question": "Which technique adds statistical noise to protect individual privacy in datasets?",
    "choice_a": "Tokenization",
    "choice_b": "Pseudonymization",
    "choice_c": "Differential privacy",
    "choice_d": "Hashing",
    "correct_answer": "C",
    "explanation": "Differential privacy introduces mathematically calibrated noise to outputs, ensuring that the presence or absence of any individual has minimal impact on results, reducing re-identification risk.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      207,
      208,
      206,
      187,
      144
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 195,
    "question": "Which combination most effectively reduces re-identification risk in AI training datasets?",
    "choice_a": "Differential privacy and aggregation",
    "choice_b": "Encryption and access control",
    "choice_c": "Pseudonymization and audit logging",
    "choice_d": "Data retention limits and patching",
    "correct_answer": "A",
    "explanation": "Differential privacy reduces the ability to infer individual contributions, while aggregation increases the size of anonymity sets. Together, these techniques significantly reduce re-identification risk in AI training datasets.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      207,
      208,
      206,
      169,
      187
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 196,
    "question": "Consent tagging primarily supports which privacy principle?",
    "choice_a": "Accountability and purpose limitation",
    "choice_b": "Availability",
    "choice_c": "Nonrepudiation",
    "choice_d": "Data portability",
    "correct_answer": "A",
    "explanation": "Consent tagging ensures that data processing aligns with declared purposes and provides traceability for compliance. This supports both accountability and purpose limitation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      144,
      170,
      167,
      193
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 197,
    "question": "Which tracking technology operates without storing data on the user’s device?",
    "choice_a": "First-party cookies",
    "choice_b": "Pixel tracking",
    "choice_c": "Device fingerprinting",
    "choice_d": "Session cookies",
    "correct_answer": "C",
    "explanation": "Device fingerprinting collects attributes such as browser type and screen resolution to uniquely identify users without storing cookies. This raises privacy concerns due to a lack of transparency and control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      198,
      197,
      204,
      139,
      203
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 198,
    "question": "Anonymization differs from pseudonymization because anonymization does which of the following?",
    "choice_a": "Uses encryption keys",
    "choice_b": "Eliminates the ability to identify individuals",
    "choice_c": "Allows re-identification",
    "choice_d": "Requires consent",
    "correct_answer": "B",
    "explanation": "Anonymization removes or transforms data so that individuals cannot be identified using reasonably available means. Pseudonymization retains a reversible link, whereas anonymization aims to remove it entirely.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      206,
      207,
      208
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 199,
    "question": "Which of the following is an example of a privacy-enhancing technology?",
    "choice_a": "Firewall",
    "choice_b": "Antivirus software",
    "choice_c": "Differential privacy",
    "choice_d": "Load balancer",
    "correct_answer": "C",
    "explanation": "Differential privacy is a privacy-enhancing technology designed specifically to protect individuals when performing statistical analysis or training machine learning models. It works by introducing mathematically calibrated noise into datasets or query outputs so that the contribution of any single individual cannot be reliably determined.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      207,
      208,
      187
    ],
    "source": "363803_Ch09"
  },
  {
    "id": 200,
    "question": "Which method replaces sensitive values with reversible substitutes stored in a separate lookup table?",
    "choice_a": "Tokenization",
    "choice_b": "Anonymization",
    "choice_c": "Aggregation",
    "choice_d": "Data masking",
    "correct_answer": "A",
    "explanation": "Tokenization substitutes sensitive values with tokens while maintaining a mapping in a secure table. Because the mapping exists, the original value can be restored under controlled conditions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      191,
      188
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 201,
    "question": "What is the primary purpose of a privacy risk assessment?",
    "choice_a": "Identify data owners",
    "choice_b": "Evaluate potential impacts to personal data",
    "choice_c": "Document system architecture",
    "choice_d": "Approve data transfers",
    "correct_answer": "B",
    "explanation": "A privacy risk assessment evaluates how processing activities could affect individuals. It identifies risks and supports appropriate mitigation decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      59,
      64,
      69,
      63
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 202,
    "question": "Which retention principle requires organizations to keep personal data only as long as necessary?",
    "choice_a": "Storage limitation",
    "choice_b": "Purpose limitation",
    "choice_c": "Transparency",
    "choice_d": "Accuracy",
    "correct_answer": "A",
    "explanation": "Storage limitation requires that personal data be retained only for the period needed to fulfill its purpose. This reduces unnecessary exposure and risk.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      127,
      128,
      120,
      119,
      111
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 203,
    "question": "A privacy program integrates policies, training, and monitoring aligned with enterprise governance. What does this demonstrate?",
    "choice_a": "Operational compliance",
    "choice_b": "Data classification accuracy",
    "choice_c": "Incident response capability",
    "choice_d": "Privacy governance maturity",
    "correct_answer": "D",
    "explanation": "Governance maturity reflects structured oversight, accountability, and alignment with enterprise objectives. Integration across policies, training, and monitoring indicates coordinated governance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      15,
      5,
      7,
      9
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 204,
    "question": "Which technology stack component most directly enforces privacy requirements in application logic?",
    "choice_a": "Network firewall",
    "choice_b": "Application layer controls",
    "choice_c": "Physical security controls",
    "choice_d": "Environmental monitoring",
    "correct_answer": "B",
    "explanation": "Application-layer controls embed privacy requirements directly into system behavior. This allows enforcement of consent, minimization, and access restrictions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      159,
      144,
      169,
      161
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 205,
    "question": "Data classification supports privacy primarily by doing which of the following?",
    "choice_a": "Increasing storage capacity",
    "choice_b": "Eliminating audit logs",
    "choice_c": "Identifying sensitivity levels for handling requirements",
    "choice_d": "Reducing processing time",
    "correct_answer": "C",
    "explanation": "Classification assigns sensitivity levels to data. This determines handling controls such as access, retention, and protection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      111,
      115,
      121,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 206,
    "question": "Which artifact demonstrates ongoing privacy program monitoring?",
    "choice_a": "Data inventory",
    "choice_b": "Privacy metrics dashboard",
    "choice_c": "Data flow diagram",
    "choice_d": "Privacy notice",
    "correct_answer": "B",
    "explanation": "Metrics dashboards track performance indicators and risk trends. They provide evidence of continuous monitoring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      91,
      66,
      93
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 207,
    "question": "Encryption primarily protects data in which of the following situations?",
    "choice_a": "During collection",
    "choice_b": "From deletion",
    "choice_c": "From classification",
    "choice_d": "From unauthorized disclosure",
    "correct_answer": "D",
    "explanation": "Encryption transforms data into a form that is unreadable without the proper encryption keys to decrypt the data. This protects confidentiality during storage and transmission.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      206,
      191,
      188,
      207
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 208,
    "question": "Which function is typically responsible for coordinating data subject request fulfillment?",
    "choice_a": "Facilities management",
    "choice_b": "Privacy operations",
    "choice_c": "Internal audit",
    "choice_d": "Procurement",
    "correct_answer": "B",
    "explanation": "Privacy operations manages processes that support individual rights. It coordinates stakeholders to fulfill requests.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      56,
      47,
      32,
      39,
      26
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 209,
    "question": "Combining multiple anonymized datasets increases which risk?",
    "choice_a": "Data corruption",
    "choice_b": "Network latency",
    "choice_c": "Linkage re-identification",
    "choice_d": "Access privilege escalation",
    "correct_answer": "C",
    "explanation": "Combining datasets can create unique attribute combinations. These can enable re-identification through linkage analysis.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      119,
      122,
      118,
      109,
      123
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 210,
    "question": "Which step follows the identification of privacy risks?",
    "choice_a": "Data destruction",
    "choice_b": "Risk response planning",
    "choice_c": "Data classification",
    "choice_d": "System shutdown",
    "correct_answer": "B",
    "explanation": "After risks are identified, mitigation strategies are selected. Risk response determines control implementation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      59,
      61,
      82,
      85
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 211,
    "question": "Differential privacy primarily introduces which of the following?",
    "choice_a": "Encryption keys",
    "choice_b": "Token values",
    "choice_c": "Data segmentation",
    "choice_d": "Statistical noise",
    "correct_answer": "D",
    "explanation": "Differential privacy adds noise to outputs. This reduces the ability to infer individual data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      207,
      206,
      208
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 212,
    "question": "Secure deletion ensures which of the following?",
    "choice_a": "Data classification accuracy",
    "choice_b": "Data is archived",
    "choice_c": "Data cannot be reconstructed",
    "choice_d": "Data is tokenized",
    "correct_answer": "C",
    "explanation": "Secure deletion removes recoverable traces of data. This prevents reconstruction from storage media.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      129,
      127,
      128,
      111,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 213,
    "question": "Privacy by design requires controls to be implemented at which point?",
    "choice_a": "After deployment",
    "choice_b": "Throughout the system lifecycle",
    "choice_c": "Only during audits",
    "choice_d": "Only during incident response",
    "correct_answer": "B",
    "explanation": "Privacy by design integrates requirements early and continuously. This ensures privacy is embedded in lifecycle activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      43,
      24,
      1,
      16
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 214,
    "question": "Which logging control best supports accountability for personal data access?",
    "choice_a": "Aggregated logs",
    "choice_b": "Detailed user activity logs",
    "choice_c": "Performance logs",
    "choice_d": "Data indexing logs",
    "correct_answer": "B",
    "explanation": "Detailed activity logs record user actions. They support traceability and accountability.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      202,
      176,
      169,
      179,
      135
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 215,
    "question": "What should privacy program metrics primarily measure?",
    "choice_a": "Effectiveness of privacy controls",
    "choice_b": "Network speed",
    "choice_c": "Hardware utilization",
    "choice_d": "Vendor profitability",
    "correct_answer": "A",
    "explanation": "Metrics evaluate whether controls reduce risk and achieve objectives. This supports program improvement by identifying controls that require remediation or improvement.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      92,
      94,
      95,
      84,
      93
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 216,
    "question": "Data minimization requires organizations to do which of the following?",
    "choice_a": "Collect all available data",
    "choice_b": "Limit data to necessary elements",
    "choice_c": "Encrypt all data",
    "choice_d": "Share data broadly",
    "correct_answer": "B",
    "explanation": "Data minimization restricts collection to necessary information. This reduces exposure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      120,
      104,
      103,
      110
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 217,
    "question": "APIs introduce privacy risk primarily because they do which of the following?",
    "choice_a": "Increase hardware usage",
    "choice_b": "Enable automated data exchange",
    "choice_c": "Reduce encryption",
    "choice_d": "Eliminate logging",
    "correct_answer": "B",
    "explanation": "APIs automate data flows between systems in the same or different organizations. Improper control can expose personal data to unauthorized parties.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      161,
      159,
      173,
      169,
      196
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 218,
    "question": "Vendor privacy risk is best reduced by which of the following?",
    "choice_a": "Increasing retention",
    "choice_b": "Removing encryption",
    "choice_c": "Contractual privacy requirements",
    "choice_d": "Expanding data access",
    "correct_answer": "C",
    "explanation": "Contracts define obligations and controls. They enforce vendor accountability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      50,
      31,
      48,
      33
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 219,
    "question": "A privacy impact assessment evaluates which of the following?",
    "choice_a": "Financial statements",
    "choice_b": "Privacy risks of processing",
    "choice_c": "Hardware lifecycle",
    "choice_d": "Employee attendance",
    "correct_answer": "B",
    "explanation": "PIAs assess impacts on individuals. They guide mitigation strategies.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      73,
      74,
      75,
      59,
      64
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 220,
    "question": "Which technique reduces identifiability by grouping individuals into sets sharing common attributes?",
    "choice_a": "k-anonymity",
    "choice_b": "Encryption",
    "choice_c": "Tokenization",
    "choice_d": "Data masking",
    "correct_answer": "A",
    "explanation": "k-anonymity ensures that each record is indistinguishable from at least k−1 others, based on selected attributes. This reduces the likelihood of identifying individuals from quasi-identifiers.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      206,
      207
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 221,
    "question": "What is the primary purpose of a data retention schedule?",
    "choice_a": "Specify how long data is stored",
    "choice_b": "Define encryption standards",
    "choice_c": "Classify data sensitivity",
    "choice_d": "Document processing purposes",
    "correct_answer": "A",
    "explanation": "A retention schedule establishes timeframes for keeping data. It supports storage limitation and consistent disposal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      129,
      111,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 222,
    "question": "Which principle emphasizes openness about personal data processing?",
    "choice_a": "Accuracy",
    "choice_b": "Transparency",
    "choice_c": "Storage limitation",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "Transparency requires organizations to clearly inform individuals about data practices. This supports trust and informed consent.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      22,
      4,
      34,
      26,
      28
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 223,
    "question": "Evidence supporting privacy compliance is best described as which of the following?",
    "choice_a": "Technical architecture diagrams",
    "choice_b": "Artifacts demonstrating control implementation",
    "choice_c": "Employee schedules",
    "choice_d": "Financial reports",
    "correct_answer": "B",
    "explanation": "Compliance evidence includes documentation and records. These demonstrate that controls are operating.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      91,
      97,
      96,
      95,
      102
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 224,
    "question": "Which control most directly protects data in transit between services?",
    "choice_a": "Network segmentation",
    "choice_b": "Transport layer encryption",
    "choice_c": "Disk encryption",
    "choice_d": "Tokenization",
    "correct_answer": "B",
    "explanation": "Transport layer encryption secures communication channels. It prevents interception during transmission.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      187,
      184,
      161,
      192,
      188
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 225,
    "question": "A data flow diagram primarily helps identify which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Encryption keys",
    "choice_c": "Movement of personal data",
    "choice_d": "Vendor contracts",
    "correct_answer": "C",
    "explanation": "Data flow diagrams visualize how data moves across systems. This supports risk identification.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      109,
      106,
      107,
      123,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 226,
    "question": "Risk response that reduces likelihood is classified as which of the following?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk transfer",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk mitigation",
    "correct_answer": "D",
    "explanation": "Mitigation introduces controls to reduce the likelihood or impact of a threat. Risk response addresses risks identified in a risk assessment, a PIA, or other means.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59,
      84,
      85
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 227,
    "question": "Incident management in privacy operations focuses on which of the following?",
    "choice_a": "Hardware procurement",
    "choice_b": "System performance tuning",
    "choice_c": "Employee hiring",
    "choice_d": "Handling personal data breaches",
    "correct_answer": "D",
    "explanation": "Privacy incidents involve unauthorized access or disclosure. Management includes detection, response, and notification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      54,
      57,
      47,
      5
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 228,
    "question": "Cloud services create privacy risk primarily due to which of the following?",
    "choice_a": "Increased processing speed",
    "choice_b": "Reduced scalability",
    "choice_c": "Shared infrastructure and data storage",
    "choice_d": "Decreased automation",
    "correct_answer": "C",
    "explanation": "Shared environments introduce multi-tenancy risks. This requires additional controls in both the service provider and the customer.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      163,
      132,
      164,
      162,
      169
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 229,
    "question": "Removing direct identifiers but leaving detailed attributes can still allow identification through which of the following?",
    "choice_a": "Encryption",
    "choice_b": "Data retention",
    "choice_c": "Attribute inference",
    "choice_d": "Logging",
    "correct_answer": "C",
    "explanation": "Detailed attributes can be combined to infer identity. This creates re-identification risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      119,
      116,
      118,
      109
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 230,
    "question": "Program monitoring ensures which of the following?",
    "choice_a": "Data deletion",
    "choice_b": "Ongoing control effectiveness",
    "choice_c": "Vendor selection",
    "choice_d": "Encryption key rotation",
    "correct_answer": "B",
    "explanation": "Monitoring evaluates whether controls continue to function. It supports continuous improvement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      61,
      94,
      95,
      60
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 231,
    "question": "Homomorphic encryption allows which of the following?",
    "choice_a": "Computation on encrypted data",
    "choice_b": "Data deletion",
    "choice_c": "Token generation",
    "choice_d": "Data masking",
    "correct_answer": "A",
    "explanation": "Homomorphic encryption permits processing without decryption. This protects the confidentiality of data stored by another party, such as a service provider.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      207,
      187,
      192,
      206,
      191
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 232,
    "question": "Privacy governance primarily establishes which of the following?",
    "choice_a": "System performance baselines",
    "choice_b": "Oversight and accountability",
    "choice_c": "Encryption standards",
    "choice_d": "Hardware inventory",
    "correct_answer": "B",
    "explanation": "Governance defines decision rights and accountability by aligning privacy with enterprise objectives.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      3,
      7,
      1,
      38,
      5
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 233,
    "question": "Data destruction policies ensure which of the following?",
    "choice_a": "Data classification",
    "choice_b": "Data transfer approval",
    "choice_c": "Secure disposal procedures",
    "choice_d": "Vendor onboarding",
    "correct_answer": "C",
    "explanation": "Destruction policies define methods for secure disposal. This prevents unauthorized recovery.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      129,
      111,
      127,
      128,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 234,
    "question": "Access control based on job responsibilities is known as which of the following?",
    "choice_a": "Mandatory access control",
    "choice_b": "Discretionary access control",
    "choice_c": "Role-based access control",
    "choice_d": "Attribute suppression",
    "correct_answer": "C",
    "explanation": "Role-based access control assigns permissions to roles. Users inherit permissions based on duties.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      174,
      176,
      173
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 235,
    "question": "Privacy risk likelihood increases when which of the following happens?",
    "choice_a": "Data is aggregated",
    "choice_b": "Data volume and sharing expand",
    "choice_c": "Data retention decreases",
    "choice_d": "Encryption is applied",
    "correct_answer": "B",
    "explanation": "Greater volume and sharing expand exposure. This increases the probability of incidents.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      75,
      99,
      59,
      62
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 236,
    "question": "Data quality supports privacy by ensuring which of the following?",
    "choice_a": "Encryption strength",
    "choice_b": "Reduced storage",
    "choice_c": "Data accuracy",
    "choice_d": "Vendor oversight",
    "correct_answer": "C",
    "explanation": "Accurate data prevents incorrect decisions that affect individuals. It supports fairness.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      103,
      110,
      104,
      119
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 237,
    "question": "Data subject access requests require organizations to do which of the following?",
    "choice_a": "Delete all data",
    "choice_b": "Classify data",
    "choice_c": "Provide individuals access to their data",
    "choice_d": "Transfer data to vendors",
    "correct_answer": "C",
    "explanation": "Access rights allow individuals to view personal data. This supports transparency.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      56,
      26,
      22,
      28,
      3
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 238,
    "question": "Model inversion attacks target which of the following?",
    "choice_a": "Encryption algorithms",
    "choice_b": "Network segmentation",
    "choice_c": "Machine learning outputs to infer training data",
    "choice_d": "Access control policies",
    "correct_answer": "C",
    "explanation": "Model inversion analyzes outputs to reconstruct inputs. This can reveal personal data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      208,
      207,
      206
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 239,
    "question": "Privacy metrics should align with which of the following?",
    "choice_a": "Vendor pricing",
    "choice_b": "Hardware lifecycle",
    "choice_c": "Data retention",
    "choice_d": "Organizational privacy objectives",
    "correct_answer": "D",
    "explanation": "Metrics must reflect program goals. Alignment ensures meaningful measurement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      90,
      87
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 240,
    "question": "Which activity ensures personal data is accurate and up to date for its intended use?",
    "choice_a": "Data quality management",
    "choice_b": "Data minimization",
    "choice_c": "Data destruction",
    "choice_d": "Tokenization",
    "correct_answer": "A",
    "explanation": "Data quality management includes processes to maintain accuracy, completeness, and timeliness. Accurate data reduces the risk of incorrect decisions affecting individuals.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      116,
      103,
      110,
      111,
      109
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 241,
    "question": "Which control ensures that only authorized users can view personal data within an application?",
    "choice_a": "Data retention schedule",
    "choice_b": "Data classification labeling",
    "choice_c": "Privacy notice",
    "choice_d": "Access control mechanisms",
    "correct_answer": "D",
    "explanation": "Access controls restrict system access based on defined permissions. This prevents unauthorized disclosure of personal data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      173,
      174,
      176,
      169,
      178
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 242,
    "question": "Which principle requires collecting only data necessary for a specific purpose?",
    "choice_a": "Data minimization",
    "choice_b": "Transparency",
    "choice_c": "Accuracy",
    "choice_d": "Accountability",
    "correct_answer": "A",
    "explanation": "Data minimization limits collection to what is required. This reduces unnecessary exposure of personal data.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      23,
      28,
      26,
      43,
      25
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 243,
    "question": "A risk assessment identifies high impact but low likelihood. What is the most appropriate next step?",
    "choice_a": "Ignore the risk",
    "choice_b": "Immediately delete data",
    "choice_c": "Remove logging controls",
    "choice_d": "Evaluate risk response options",
    "correct_answer": "D",
    "explanation": "After identifying risk characteristics, appropriate responses must be evaluated. Decisions can include mitigation, transfer, acceptance, or avoidance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59,
      82,
      85
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 244,
    "question": "Which technique adds uncertainty to query results to protect individual privacy?",
    "choice_a": "Data masking",
    "choice_b": "Encryption",
    "choice_c": "Tokenization",
    "choice_d": "Differential privacy",
    "correct_answer": "D",
    "explanation": "Differential privacy introduces statistical noise into outputs. This limits the ability to infer individual records.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      207,
      206
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 245,
    "question": "Data archiving differs from active storage because archived data is:",
    "choice_a": "Immediately deleted",
    "choice_b": "Publicly accessible",
    "choice_c": "Automatically anonymized",
    "choice_d": "Stored for long-term retention with limited access",
    "correct_answer": "D",
    "explanation": "Archiving retains data for compliance or historical purposes. Access is restricted to reduce exposure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      128,
      127,
      121,
      129,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 246,
    "question": "Vendor management supports privacy by doing which of the following?",
    "choice_a": "Increasing data sharing",
    "choice_b": "Eliminating data retention",
    "choice_c": "Ensuring that third parties meet privacy requirements",
    "choice_d": "Disabling encryption",
    "correct_answer": "C",
    "explanation": "Vendor management evaluates and monitors third-party privacy practices. This reduces external processing risks.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      50,
      52,
      49,
      51,
      48
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 247,
    "question": "Privacy metrics are used to do which of the following?",
    "choice_a": "Measure the effectiveness of privacy controls",
    "choice_b": "Increase hardware performance",
    "choice_c": "Define data classification",
    "choice_d": "Manage facilities",
    "correct_answer": "A",
    "explanation": "Metrics assess how well controls reduce risk. They support continuous improvement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      84,
      61,
      66
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 248,
    "question": "Microservices architectures increase privacy risk primarily due to which of the following?",
    "choice_a": "Distributed data processing components",
    "choice_b": "Reduced scalability",
    "choice_c": "Lower automation",
    "choice_d": "Simplified logging",
    "correct_answer": "A",
    "explanation": "Distributed services increase data flows. More interfaces require stronger privacy controls across all microservices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      169,
      159,
      163,
      144
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 249,
    "question": "Combining anonymized datasets from different sources can lead to identification through which of the following?",
    "choice_a": "Encryption failure",
    "choice_b": "Correlation of quasi-identifiers",
    "choice_c": "Data minimization",
    "choice_d": "Data retention",
    "correct_answer": "B",
    "explanation": "Quasi-identifiers across datasets can uniquely identify individuals. This is a linkage re-identification risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      119,
      118,
      116,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 250,
    "question": "Risk transfer is achieved primarily through which of the following?",
    "choice_a": "Encryption",
    "choice_b": "Data classification",
    "choice_c": "Insurance or contractual allocation",
    "choice_d": "Data deletion",
    "correct_answer": "C",
    "explanation": "Risk transfer shifts responsibility to another party. Contracts or insurance are common mechanisms.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59,
      84,
      60
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 251,
    "question": "Logging personal data access supports which of the following?",
    "choice_a": "Data minimization",
    "choice_b": "Data retention",
    "choice_c": "Accountability",
    "choice_d": "Data aggregation",
    "correct_answer": "C",
    "explanation": "Logs record user actions. This enables traceability and accountability.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      173,
      179,
      135,
      180,
      203
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 252,
    "question": "Privacy governance should align with which of the following?",
    "choice_a": "Vendor pricing models",
    "choice_b": "Enterprise governance structure",
    "choice_c": "Hardware lifecycle",
    "choice_d": "Network topology",
    "correct_answer": "B",
    "explanation": "Alignment ensures privacy objectives support organizational goals. Governance integration improves oversight.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      7,
      38,
      1,
      2
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 253,
    "question": "Secure disposal of backup media prevents which of the following?",
    "choice_a": "Data classification errors",
    "choice_b": "Data aggregation",
    "choice_c": "Data transfer delays",
    "choice_d": "Unauthorized data recovery",
    "correct_answer": "D",
    "explanation": "Secure disposal removes recoverable data from media. This protects confidentiality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      125,
      111,
      127,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 254,
    "question": "Federated learning enhances privacy by doing which of the following?",
    "choice_a": "Eliminating encryption",
    "choice_b": "Removing logging",
    "choice_c": "Aggregating identifiers",
    "choice_d": "Keeping data local during training",
    "correct_answer": "D",
    "explanation": "Federated learning trains models locally. Only model updates are shared, reducing exposure.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      208,
      207,
      206
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 255,
    "question": "Which metric best indicates the effectiveness of breach response?",
    "choice_a": "Mean time to containment",
    "choice_b": "Number of systems deployed",
    "choice_c": "Data classification accuracy",
    "choice_d": "Storage utilization",
    "correct_answer": "A",
    "explanation": "Mean time to containment measures how quickly incidents are brought under control. Faster containment reduces impact.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      92,
      94,
      59,
      66
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 256,
    "question": "Data inventory supports privacy by doing which of the following?",
    "choice_a": "Identifying where personal data resides",
    "choice_b": "Increasing storage",
    "choice_c": "Removing encryption",
    "choice_d": "Eliminating logging",
    "correct_answer": "A",
    "explanation": "Inventory provides visibility into data locations. This helps an organization protect personal information more effectively because it knows where it resides.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      105,
      109,
      125,
      103,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 257,
    "question": "Data subject rights management includes which of the following?",
    "choice_a": "Encryption key rotation",
    "choice_b": "Data classification",
    "choice_c": "Handling access and deletion requests",
    "choice_d": "Vendor selection",
    "correct_answer": "C",
    "explanation": "Rights management processes respond to individual requests. This supports compliance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      26,
      28,
      29,
      34
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 258,
    "question": "APIs should implement authentication to do which of the following?",
    "choice_a": "Improve performance",
    "choice_b": "Verify requester identity",
    "choice_c": "Reduce logging",
    "choice_d": "Increase retention",
    "correct_answer": "B",
    "explanation": "Authentication ensures that only authorized entities have access to data. This reduces unauthorized exposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      176,
      159,
      173,
      177
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 259,
    "question": "Risk acceptance occurs when which of the following happens?",
    "choice_a": "Controls are removed",
    "choice_b": "Risk is acknowledged without mitigation",
    "choice_c": "Data is encrypted",
    "choice_d": "Data is deleted",
    "correct_answer": "B",
    "explanation": "Risk acceptance acknowledges an identified risk. The organization decides no further action is needed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59,
      82,
      84
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 260,
    "question": "Which activity ensures that data is securely removed when no longer needed?",
    "choice_a": "Data aggregation",
    "choice_b": "Data classification",
    "choice_c": "Data destruction",
    "choice_d": "Data transfer",
    "correct_answer": "C",
    "explanation": "Data destruction applies secure deletion techniques to prevent recovery. It supports storage limitation and reduces residual risk.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      129,
      111,
      128,
      127,
      120
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 261,
    "question": "Which privacy-enhancing technique allows statistical analysis without revealing individual records?",
    "choice_a": "Tokenization",
    "choice_b": "Access control",
    "choice_c": "Differential privacy",
    "choice_d": "Data retention",
    "correct_answer": "C",
    "explanation": "Differential privacy adds noise to outputs. This prevents inference about individual records while preserving overall trends.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      207,
      206,
      169
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 262,
    "question": "Accountability in privacy governance means which of the following?",
    "choice_a": "Assigning responsibility for privacy decisions",
    "choice_b": "Deleting all data",
    "choice_c": "Encrypting data",
    "choice_d": "Classifying hardware",
    "correct_answer": "A",
    "explanation": "Accountability ensures roles are defined for privacy oversight. Responsible parties are held accountable for compliance.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      39,
      38,
      3,
      33,
      42
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 263,
    "question": "A risk assessment indicates that a processing activity has high likelihood and moderate impact. What should guide prioritization?",
    "choice_a": "Vendor contracts",
    "choice_b": "Risk scoring methodology",
    "choice_c": "Data classification labels",
    "choice_d": "Logging frequency",
    "correct_answer": "B",
    "explanation": "Risk scoring combines likelihood and impact. It supports prioritizing mitigation efforts.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      70,
      69,
      82,
      59,
      60
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 264,
    "question": "Which control protects personal data stored on disks?",
    "choice_a": "Transport encryption",
    "choice_b": "Encryption at rest",
    "choice_c": "Tokenization",
    "choice_d": "Data masking",
    "correct_answer": "B",
    "explanation": "Encryption at rest secures stored data. Unauthorized users cannot read data without keys.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      191,
      192,
      188,
      185
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 265,
    "question": "Data flow mapping helps identify which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Vendor costs",
    "choice_c": "Encryption algorithms",
    "choice_d": "Points where personal data is processed",
    "correct_answer": "D",
    "explanation": "Mapping shows how data moves between systems. This helps identify risk exposure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      109,
      106,
      107,
      105,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 266,
    "question": "Privacy incident response includes which of the following?",
    "choice_a": "Hardware deployment",
    "choice_b": "Data classification",
    "choice_c": "Investigation and notification steps",
    "choice_d": "Tokenization",
    "correct_answer": "C",
    "explanation": "Incident response addresses breaches involving personal data. It includes containment and notification.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      53,
      57,
      54,
      5,
      12
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 267,
    "question": "Privacy program monitoring aims to do which of the following?",
    "choice_a": "Evaluate control performance",
    "choice_b": "Increase data volume",
    "choice_c": "Reduce encryption",
    "choice_d": "Eliminate logging",
    "correct_answer": "A",
    "explanation": "Monitoring measures whether controls operate effectively. It supports improvements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      95,
      93,
      61
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 268,
    "question": "Cloud-native services increase privacy risk because they do which of the following?",
    "choice_a": "Reduce scalability",
    "choice_b": "Increase distributed data handling",
    "choice_c": "Eliminate logging",
    "choice_d": "Remove authentication",
    "correct_answer": "B",
    "explanation": "Distributed services create more data flows. This increases exposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      164,
      163,
      162,
      166
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 269,
    "question": "Aggregating datasets while retaining granular attributes increases the risk of which of the following?",
    "choice_a": "Data retention",
    "choice_b": "Re-identification",
    "choice_c": "Encryption failure",
    "choice_d": "Storage limitation",
    "correct_answer": "B",
    "explanation": "Detailed attributes might uniquely identify individuals. This creates linkage risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      119,
      118,
      116,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 270,
    "question": "Risk avoidance is achieved by doing which of the following?",
    "choice_a": "Accepting residual risk",
    "choice_b": "Eliminating the risky activity",
    "choice_c": "Encrypting data",
    "choice_d": "Logging access",
    "correct_answer": "B",
    "explanation": "Avoidance removes the source of risk. Processing is discontinued.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      83,
      59,
      84,
      82
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 271,
    "question": "Secure multi-party computation allows which of the following?",
    "choice_a": "Joint analysis without sharing raw data",
    "choice_b": "Data deletion",
    "choice_c": "Tokenization",
    "choice_d": "Data masking",
    "correct_answer": "A",
    "explanation": "Parties compute results collaboratively. Raw data remains private.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      207,
      187,
      189,
      206,
      173
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 272,
    "question": "Privacy governance policies should do which of the following?",
    "choice_a": "Focus only on technology",
    "choice_b": "Eliminate data retention",
    "choice_c": "Remove access controls",
    "choice_d": "Define organizational privacy expectations",
    "correct_answer": "D",
    "explanation": "Policies establish standards and expectations. They guide implementation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      31,
      10,
      1,
      16
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 273,
    "question": "Retention limits help reduce which of the following?",
    "choice_a": "Exposure of unnecessary data",
    "choice_b": "Hardware cost",
    "choice_c": "Encryption strength",
    "choice_d": "Logging requirements",
    "correct_answer": "A",
    "explanation": "Limiting retention reduces stored personal data. This lowers breach impact.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      121,
      120,
      119
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 274,
    "question": "Multi-factor authentication improves privacy by doing which of the following?",
    "choice_a": "Increasing retention",
    "choice_b": "Removing logging",
    "choice_c": "Strengthening user verification",
    "choice_d": "Aggregating data",
    "correct_answer": "C",
    "explanation": "MFA requires multiple forms of identification, reducing the risk of unauthorized access.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      178,
      176,
      173,
      177,
      159
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 275,
    "question": "Which metric best reflects data subject request performance?",
    "choice_a": "System uptime",
    "choice_b": "Data retention period",
    "choice_c": "Vendor count",
    "choice_d": "Average request fulfillment time",
    "correct_answer": "D",
    "explanation": "Fulfillment time measures responsiveness. It indicates operational effectiveness.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      102
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 276,
    "question": "Data classification supports privacy by doing which of the following?",
    "choice_a": "Increasing sharing",
    "choice_b": "Removing encryption",
    "choice_c": "Deleting logs",
    "choice_d": "Identifying sensitivity levels",
    "correct_answer": "D",
    "explanation": "Sensitivity labels determine protection requirements. This ensures appropriate handling.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      111,
      115,
      121,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 277,
    "question": "Vendor privacy due diligence evaluates which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Third-party data protection practices",
    "choice_c": "Network bandwidth",
    "choice_d": "Storage capacity and availability",
    "correct_answer": "B",
    "explanation": "Due diligence assesses vendor controls. It reduces outsourcing risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      52,
      51,
      49,
      12,
      50
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 278,
    "question": "How does the secure development lifecycle integrate privacy?",
    "choice_a": "After deployment",
    "choice_b": "Only during audits",
    "choice_c": "Throughout development stages",
    "choice_d": "Only during incidents",
    "correct_answer": "C",
    "explanation": "Privacy requirements are incorporated early. This reduces design flaws that would be more costly to remediate after development.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      144,
      142,
      146,
      145,
      148
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 279,
    "question": "Residual risk is which of the following?",
    "choice_a": "Eliminated risk",
    "choice_b": "Remaining risk after controls",
    "choice_c": "Transferred risk",
    "choice_d": "Avoided risk",
    "correct_answer": "B",
    "explanation": "Residual risk remains after mitigation. It must be accepted or further addressed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      65,
      83,
      59,
      85
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 280,
    "question": "Data provenance primarily documents which of the following?",
    "choice_a": "Data deletion methods",
    "choice_b": "Origin and history of data",
    "choice_c": "Encryption algorithms",
    "choice_d": "Legality of use",
    "correct_answer": "B",
    "explanation": "Data provenance tracks where data originated and how it has been processed. This supports accountability and data integrity.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      106,
      108,
      107,
      103,
      109
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 281,
    "question": "Which technique replaces identifiers but allows re-linking through controlled mapping?",
    "choice_a": "Anonymization",
    "choice_b": "Aggregation",
    "choice_c": "Differential privacy",
    "choice_d": "Tokenization",
    "correct_answer": "D",
    "explanation": "Tokenization substitutes identifiers while preserving a re-identification key. This reduces risk while maintaining usability.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      206
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 282,
    "question": "Privacy governance defines which of the following?",
    "choice_a": "Network architecture",
    "choice_b": "Encryption key rotation",
    "choice_c": "Organizational oversight for privacy",
    "choice_d": "Hardware lifecycle",
    "correct_answer": "C",
    "explanation": "Governance establishes accountability and decision authority. It aligns privacy activities with enterprise objectives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      7,
      40,
      3,
      38
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 283,
    "question": "When a privacy risk cannot be reduced economically, the organization should do which of the following?",
    "choice_a": "Delete all data",
    "choice_b": "Disable logging",
    "choice_c": "Remove policies",
    "choice_d": "Evaluate risk acceptance",
    "correct_answer": "D",
    "explanation": "Risk acceptance occurs when mitigation is impractical, such as when the organization is unwilling to mitigate the risk or discontinue the related activity. The organization formally acknowledges residual risk.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      83,
      65,
      59,
      85,
      84
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 284,
    "question": "Which control ensures auditability of personal data access?",
    "choice_a": "Data classification",
    "choice_b": "Logging and monitoring",
    "choice_c": "Data retention",
    "choice_d": "Tokenization",
    "correct_answer": "B",
    "explanation": "Logging captures access events. Monitoring detects anomalies and supports accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      181,
      135,
      176,
      180
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 285,
    "question": "Data retention policies should be based primarily on which of the following?",
    "choice_a": "Hardware capacity",
    "choice_b": "Storage capacity",
    "choice_c": "Encryption strength",
    "choice_d": "Legal and business requirements",
    "correct_answer": "D",
    "explanation": "Retention must satisfy regulatory and operational needs. This ensures compliance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      103,
      111,
      117
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 286,
    "question": "Data subject rectification requests involve which of the following?",
    "choice_a": "Deleting data",
    "choice_b": "Transferring data",
    "choice_c": "Correcting inaccurate personal data",
    "choice_d": "Encrypting data",
    "correct_answer": "C",
    "explanation": "Rectification rights allow individuals to correct errors. This improves data accuracy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      26,
      28,
      55,
      22
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 287,
    "question": "Compliance artifacts provide which of the following?",
    "choice_a": "System performance data",
    "choice_b": "Network metrics",
    "choice_c": "Evidence of control operation",
    "choice_d": "Storage utilization",
    "correct_answer": "C",
    "explanation": "Artifacts demonstrate the implementation of privacy controls. They support reviews, audits, and compliance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      91,
      95,
      97,
      96,
      84
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 288,
    "question": "Containers increase privacy risk when which of the following is true?",
    "choice_a": "Secrets are embedded in system images",
    "choice_b": "Data is centralized",
    "choice_c": "Logging is enabled",
    "choice_d": "Encryption is applied",
    "correct_answer": "A",
    "explanation": "Embedded secrets can expose credentials. This risks unauthorized access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      159,
      183,
      191,
      187,
      161
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 289,
    "question": "Removing identifiers but keeping rare attributes increases which of the following?",
    "choice_a": "Re-identification probability",
    "choice_b": "Data minimization",
    "choice_c": "Data retention",
    "choice_d": "Encryption strength",
    "correct_answer": "A",
    "explanation": "Rare attributes (such as an exact date of birth, an uncommon ethnicity, or a rare first- and last-name combination) can uniquely identify individuals. This creates linkage risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      120,
      116,
      104
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 290,
    "question": "Risk mitigation aims to do which of the following?",
    "choice_a": "Reduce likelihood or impact",
    "choice_b": "Eliminate documentation",
    "choice_c": "Transfer ownership",
    "choice_d": "Remove monitoring",
    "correct_answer": "A",
    "explanation": "Mitigation introduces controls. It reduces risk exposure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      84,
      85,
      59
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 291,
    "question": "Data masking is typically used to do which of the following?",
    "choice_a": "Encrypt data",
    "choice_b": "Delete data",
    "choice_c": "Obscure values in non-production environments",
    "choice_d": "Classify data",
    "correct_answer": "C",
    "explanation": "Masking replaces sensitive values. This protects confidentiality in testing.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      206,
      148,
      149,
      207,
      152
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 292,
    "question": "Privacy principles guide which of the following?",
    "choice_a": "Design and operational decisions",
    "choice_b": "Hardware procurement",
    "choice_c": "Encryption algorithms",
    "choice_d": "Storage capacity",
    "correct_answer": "A",
    "explanation": "Principles shape policies and controls. They ensure consistent implementation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      21,
      10,
      16,
      1
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 293,
    "question": "Archiving personal data requires which of the following?",
    "choice_a": "Immediate deletion",
    "choice_b": "Public access",
    "choice_c": "Controlled long-term storage",
    "choice_d": "Removal of logging",
    "correct_answer": "C",
    "explanation": "Archived data is retained securely. Access to archived data is limited.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      121,
      125,
      127,
      111,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 294,
    "question": "Role-based access control assigns permissions based on which of the following?",
    "choice_a": "Data classification",
    "choice_b": "Encryption keys",
    "choice_c": "Job responsibilities",
    "choice_d": "Vendor contracts",
    "correct_answer": "C",
    "explanation": "Roles reflect duties. Users inherit permissions.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      174,
      173,
      179,
      180,
      178
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 295,
    "question": "Which indicator best measures privacy training effectiveness?",
    "choice_a": "Number of employees",
    "choice_b": "Storage capacity",
    "choice_c": "Vendor count",
    "choice_d": "Reduction in privacy incidents",
    "correct_answer": "D",
    "explanation": "Fewer incidents indicate improved awareness. This reflects training success.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      76,
      93,
      102
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 296,
    "question": "Data lineage tracks which of the following?",
    "choice_a": "Data deletion",
    "choice_b": "Data movement through systems",
    "choice_c": "Encryption algorithms",
    "choice_d": "Data subject requests",
    "correct_answer": "B",
    "explanation": "Lineage documents data flows. It supports transparency.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      106,
      107,
      108,
      109,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 297,
    "question": "When should vendor privacy assessments occur?",
    "choice_a": "Before onboarding and periodically",
    "choice_b": "After contract termination",
    "choice_c": "Only during incidents",
    "choice_d": "Only annually",
    "correct_answer": "A",
    "explanation": "Ongoing assessments ensure compliance. Risks change over time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      52,
      51,
      5,
      55,
      1
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 298,
    "question": "Secure coding practices reduce privacy risk by doing which of the following?",
    "choice_a": "Preventing vulnerabilities that expose data",
    "choice_b": "Increasing retention",
    "choice_c": "Removing encryption",
    "choice_d": "Eliminating logging",
    "correct_answer": "A",
    "explanation": "Secure coding reduces exploitable flaws. This protects personal data.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      159,
      182,
      161,
      142,
      175
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 299,
    "question": "Risk scoring combines which of the following?",
    "choice_a": "Storage and bandwidth",
    "choice_b": "Likelihood and impact",
    "choice_c": "Vendor cost and duration",
    "choice_d": "Logging and encryption",
    "correct_answer": "B",
    "explanation": "Risk scoring quantifies severity. It guides prioritization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      70,
      59,
      82
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 300,
    "question": "Data disposal verification ensures which of the following?",
    "choice_a": "Data classification",
    "choice_b": "Encryption keys rotated",
    "choice_c": "Data aggregated",
    "choice_d": "Destruction procedures were completed",
    "correct_answer": "D",
    "explanation": "Verification confirms destruction. It provides assurance.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      129,
      111,
      127,
      128,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 301,
    "question": "How does homomorphic encryption allow processing?",
    "choice_a": "After decryption",
    "choice_b": "Only in test systems",
    "choice_c": "Only during transfer",
    "choice_d": "Without decrypting data",
    "correct_answer": "D",
    "explanation": "Data remains encrypted during computation. This protects confidentiality.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      207,
      187,
      206,
      191
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 302,
    "question": "Accountability requires that organizations do which of the following?",
    "choice_a": "Delete logs",
    "choice_b": "Remove encryption",
    "choice_c": "Increase retention",
    "choice_d": "Demonstrate compliance",
    "correct_answer": "D",
    "explanation": "Accountability requires proof of compliance. Documentation and records support this.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      3,
      57,
      5,
      33
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 303,
    "question": "Privacy dashboards provide which of the following?",
    "choice_a": "Data deletion",
    "choice_b": "Encryption keys",
    "choice_c": "Visual representation of metrics",
    "choice_d": "Vendor contracts",
    "correct_answer": "C",
    "explanation": "Dashboards display performance indicators. They aid oversight.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      91,
      95
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 304,
    "question": "Attribute-based access control determines permissions using which of the following?",
    "choice_a": "Static roles only",
    "choice_b": "Encryption keys",
    "choice_c": "Multiple contextual attributes",
    "choice_d": "Data retention periods",
    "correct_answer": "C",
    "explanation": "Attributes include user, resource, and environment. Access decisions are dynamic and context-aware.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      174,
      173,
      185,
      138,
      179
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 305,
    "question": "Data aggregation supports privacy by doing which of the following?",
    "choice_a": "Reducing identifiability",
    "choice_b": "Increasing detail",
    "choice_c": "Eliminating retention",
    "choice_d": "Removing logging",
    "correct_answer": "A",
    "explanation": "Aggregated data removes individual-level detail. This lowers re-identification risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      122,
      119,
      126,
      121
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 306,
    "question": "Data portability requests require that organizations do which of the following?",
    "choice_a": "Delete data",
    "choice_b": "Encrypt logs",
    "choice_c": "Provide data in a usable format",
    "choice_d": "Transfer ownership",
    "correct_answer": "C",
    "explanation": "Portability allows individuals to reuse data. Format must be structured.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      56,
      34,
      28,
      29
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 307,
    "question": "A risk register documents which of the following?",
    "choice_a": "Hardware inventory",
    "choice_b": "Encryption keys",
    "choice_c": "Identified risks and responses",
    "choice_d": "Data classification",
    "correct_answer": "C",
    "explanation": "Registers track risk status. They support management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      59,
      82,
      83,
      66,
      65
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 308,
    "question": "Infrastructure-as-code can introduce privacy risk when which of the following happens?",
    "choice_a": "Logging is enabled",
    "choice_b": "Encryption is applied",
    "choice_c": "Access is restricted",
    "choice_d": "Sensitive values are stored in scripts",
    "correct_answer": "D",
    "explanation": "Scripts can expose credentials. This risks unauthorized access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      135,
      140,
      185,
      138
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 309,
    "question": "When should retention schedules be reviewed?",
    "choice_a": "Never",
    "choice_b": "Only during incidents",
    "choice_c": "Periodically",
    "choice_d": "Only after deletion",
    "correct_answer": "C",
    "explanation": "Reviews ensure that schedules remain appropriate. Requirements change from time to time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      128,
      127,
      103,
      105,
      117
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 310,
    "question": "Embedding privacy into governance committees demonstrates which of the following?",
    "choice_a": "Data classification",
    "choice_b": "Organizational accountability",
    "choice_c": "Encryption strength",
    "choice_d": "Compliance",
    "correct_answer": "B",
    "explanation": "Governance integration assigns oversight responsibilities. This improves accountability.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      3,
      41,
      40,
      38,
      39
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 311,
    "question": "Key performance indicators differ from key risk indicators because KPIs measure which of the following?",
    "choice_a": "Risk likelihood",
    "choice_b": "Vendor contracts",
    "choice_c": "Encryption strength",
    "choice_d": "Program performance",
    "correct_answer": "D",
    "explanation": "KPIs track the achievement of objectives. KRIs track risk exposure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 312,
    "question": "Synthetic data supports privacy by doing which of the following?",
    "choice_a": "Generating artificial datasets",
    "choice_b": "Encrypting data",
    "choice_c": "Deleting logs",
    "choice_d": "Classifying data",
    "correct_answer": "A",
    "explanation": "Synthetic data mimics patterns without real individuals’ data. This reduces or eliminates exposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      206,
      208
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 313,
    "question": "Data classification helps determine which of the following?",
    "choice_a": "Protection requirements",
    "choice_b": "Network topology",
    "choice_c": "Hardware lifecycle",
    "choice_d": "Vendor pricing",
    "correct_answer": "A",
    "explanation": "Classification defines handling controls. Sensitive data requires stronger protection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      111,
      115,
      121,
      103
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 314,
    "question": "Incident notification requirements depend on which of the following?",
    "choice_a": "Legal and regulatory obligations",
    "choice_b": "Storage capacity",
    "choice_c": "Encryption algorithms",
    "choice_d": "Data classification labels",
    "correct_answer": "A",
    "explanation": "Laws and contractual obligations define notification thresholds. Organizations must comply.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      25,
      27,
      53,
      26
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 315,
    "question": "When should residual risk evaluation occur?",
    "choice_a": "Before risk identification",
    "choice_b": "After data deletion",
    "choice_c": "Before governance approval",
    "choice_d": "After mitigation implementation",
    "correct_answer": "D",
    "explanation": "Residual risk remains after controls. Evaluation determines acceptance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      65,
      83,
      66,
      61
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 316,
    "question": "Least privilege principle ensures which of the following?",
    "choice_a": "Maximum access",
    "choice_b": "Unlimited retention",
    "choice_c": "Shared credentials",
    "choice_d": "Minimum necessary permissions",
    "correct_answer": "D",
    "explanation": "Least privilege restricts access to only those individuals who require access to perform their stated job duties. This reduces exposure.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      174,
      173,
      176,
      179,
      180
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 317,
    "question": "Secure wipe differs from deletion because it does which of the following?",
    "choice_a": "Overwrites storage media",
    "choice_b": "Changes classification",
    "choice_c": "Transfers data",
    "choice_d": "Archives data",
    "correct_answer": "A",
    "explanation": "Overwriting prevents recovery. Simple deletion does not.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      129,
      127,
      128
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 318,
    "question": "Privacy policies should be approved by which group?",
    "choice_a": "Senior management",
    "choice_b": "System administrators",
    "choice_c": "Vendors",
    "choice_d": "End users",
    "correct_answer": "A",
    "explanation": "Management approval establishes authority. Policies guide implementation.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      33,
      1,
      41,
      17,
      38
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 319,
    "question": "Continuous monitoring supports privacy by doing which of the following?",
    "choice_a": "Eliminating encryption",
    "choice_b": "Increasing retention",
    "choice_c": "Removing logging",
    "choice_d": "Detecting control failures",
    "correct_answer": "D",
    "explanation": "Monitoring identifies deviations. This supports corrective action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      61,
      66,
      92,
      94,
      60
    ],
    "source": "363803_Practice_Exam 1"
  },
  {
    "id": 320,
    "question": "What is the primary objective of a privacy risk register?",
    "choice_a": "Define encryption standards",
    "choice_b": "Track vendor performance",
    "choice_c": "Document identified risks and mitigation actions",
    "choice_d": "Store audit logs",
    "correct_answer": "C",
    "explanation": "A privacy risk register records identified risks, their severity, and mitigation strategies. It supports ongoing tracking and management of privacy risks through completion of risk treatment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      59,
      82,
      66,
      83,
      84
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 321,
    "question": "Secure development lifecycle practices aim to do which of the following?",
    "choice_a": "Increase system uptime",
    "choice_b": "Reduce storage capacity",
    "choice_c": "Eliminate monitoring",
    "choice_d": "Integrate privacy and security into development",
    "correct_answer": "D",
    "explanation": "Secure development lifecycle integrates privacy and security requirements throughout development. This reduces vulnerabilities that could expose personal data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      142,
      144,
      145,
      156,
      159
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 322,
    "question": "Data retention requirements should be aligned primarily with which of the following?",
    "choice_a": "Legal and business needs",
    "choice_b": "Hardware lifecycle",
    "choice_c": "Vendor contracts only",
    "choice_d": "Storage capacity",
    "correct_answer": "A",
    "explanation": "Retention periods must satisfy legal obligations and operational requirements. This ensures compliance and reduces unnecessary storage.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      128,
      103,
      111,
      117
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 323,
    "question": "Assigning privacy accountability to executive leadership primarily supports which of the following?",
    "choice_a": "Data classification",
    "choice_b": "Organizational governance effectiveness",
    "choice_c": "Encryption strength",
    "choice_d": "Data minimization",
    "correct_answer": "B",
    "explanation": "Executive accountability ensures oversight at the highest level. This strengthens governance and decision-making, leading to improved outcomes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      40,
      5,
      38,
      1
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 324,
    "question": "Which technique reduces identifiability by substituting specific data values with value ranges?",
    "choice_a": "Encryption",
    "choice_b": "Data masking",
    "choice_c": "Tokenization",
    "choice_d": "Generalization",
    "correct_answer": "D",
    "explanation": "Generalization replaces specific values with broader categories, such as ranges. This reduces uniqueness and re-identification risk.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      206,
      207
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 325,
    "question": "Privacy metrics are most useful when they do which of the following?",
    "choice_a": "Focus only on technical controls",
    "choice_b": "Track hardware utilization",
    "choice_c": "Align with program objectives",
    "choice_d": "Measure vendor revenue",
    "correct_answer": "C",
    "explanation": "Metrics aligned with objectives measure effectiveness. They support decision-making, policy achievement, and compliance.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      92,
      94,
      93,
      90,
      102
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 326,
    "question": "Data discovery tools primarily help organizations do which of the following?",
    "choice_a": "Encrypt data",
    "choice_b": "Delete logs",
    "choice_c": "Identify locations of personal data",
    "choice_d": "Increase retention",
    "correct_answer": "C",
    "explanation": "Discovery tools scan systems to locate personal data in structured and unstructured data stores. This supports inventory, classification, and protection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      105,
      112,
      109,
      115,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 327,
    "question": "Data subject access requests allow individuals to do which of the following?",
    "choice_a": "Delete logs",
    "choice_b": "Classify data",
    "choice_c": "View their personal data",
    "choice_d": "Increase retention",
    "correct_answer": "C",
    "explanation": "Data subject access requests (DSARs) provide individuals with visibility into their data. This supports transparency.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      56,
      26,
      22,
      34,
      28
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 328,
    "question": "When does encryption in transit protect data?",
    "choice_a": "During transmission between systems",
    "choice_b": "During storage",
    "choice_c": "During classification",
    "choice_d": "During deletion",
    "correct_answer": "A",
    "explanation": "Encryption in transit secures communication channels. This prevents eavesdropping and interception.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      185,
      187,
      184,
      203
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 329,
    "question": "Removing identifiers while retaining granular timestamps increases the risk of which of the following?",
    "choice_a": "Data aggregation",
    "choice_b": "Re-identification",
    "choice_c": "Encryption failure",
    "choice_d": "Retention violation",
    "correct_answer": "B",
    "explanation": "Detailed timestamps, such as consent date, collection date, or last login time, can uniquely identify individuals. This increases re-identification risk.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      122,
      119,
      121,
      126,
      116
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 330,
    "question": "Risk mitigation reduces risk by doing which of the following?",
    "choice_a": "Implementing controls",
    "choice_b": "Eliminating documentation",
    "choice_c": "Increasing retention",
    "choice_d": "Disabling monitoring",
    "correct_answer": "A",
    "explanation": "Controls reduce a risk’s likelihood or impact. This lowers exposure.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      84,
      83,
      65,
      85,
      69
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 331,
    "question": "Synthetic data is best described as which of the following?",
    "choice_a": "Encrypted data",
    "choice_b": "Masked production data",
    "choice_c": "Artificially generated data resembling real data",
    "choice_d": "Aggregated data",
    "correct_answer": "C",
    "explanation": "Synthetic data mimics patterns without including data about real individuals. This reduces privacy risk.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      206,
      207,
      208
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 332,
    "question": "Privacy governance policies should be which of the following?",
    "choice_a": "Informal recommendations",
    "choice_b": "Approved and documented",
    "choice_c": "Optional guidelines",
    "choice_d": "Vendor-created documents",
    "correct_answer": "B",
    "explanation": "Approved policies define enforceable expectations. They guide the implementation of processes, procedures, and systems.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      33,
      31,
      10,
      1,
      7
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 333,
    "question": "Secure deletion ensures that data:",
    "choice_a": "Is archived",
    "choice_b": "Cannot be recovered",
    "choice_c": "Is encrypted",
    "choice_d": "Is classified",
    "correct_answer": "B",
    "explanation": "Secure deletion removes recoverable traces of data. This protects confidentiality.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      129,
      127,
      111,
      121,
      128
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 334,
    "question": "Least privilege supports privacy by doing which of the following?",
    "choice_a": "Granting full access",
    "choice_b": "Limiting user permissions",
    "choice_c": "Increasing retention",
    "choice_d": "Removing encryption",
    "correct_answer": "B",
    "explanation": "Least privilege restricts access to data. This reduces exposure.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      174,
      173,
      179,
      176,
      180
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 335,
    "question": "Which metric best reflects privacy incident detection capability?",
    "choice_a": "Number of employees",
    "choice_b": "Mean time to detect incidents",
    "choice_c": "Storage utilization",
    "choice_d": "Vendor count",
    "correct_answer": "B",
    "explanation": "Detection time measures responsiveness. Earlier detection reduces the impact of an incident.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      92,
      101,
      94,
      59,
      102
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 336,
    "question": "Data lineage primarily tracks which of the following?",
    "choice_a": "Data movement through systems",
    "choice_b": "Data destruction",
    "choice_c": "Encryption algorithms",
    "choice_d": "Vendor contracts",
    "correct_answer": "A",
    "explanation": "Data lineage documents the flows and transformations of data within an organization. This supports transparency.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      106,
      107,
      108,
      109,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 337,
    "question": "Vendor privacy assessments should include which of the following?",
    "choice_a": "Data protection controls",
    "choice_b": "Hardware performance",
    "choice_c": "Disaster recovery",
    "choice_d": "Storage capacity",
    "correct_answer": "A",
    "explanation": "Assessments evaluate vendor privacy controls and safeguards. This reduces third-party risk.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      52,
      51,
      49,
      50,
      35
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 338,
    "question": "APIs require authentication to do which of the following?",
    "choice_a": "Increase speed",
    "choice_b": "Reduce logging",
    "choice_c": "Increase retention",
    "choice_d": "Verify requester identity",
    "correct_answer": "D",
    "explanation": "Authentication ensures only authorized access requests are fulfilled. This protects personal data from unauthorized access and/or tampering.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      161,
      176,
      159,
      173,
      177
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 339,
    "question": "Data classification schemes primarily help organizations do which of the following?",
    "choice_a": "Increase storage capacity",
    "choice_b": "Reduce network bandwidth",
    "choice_c": "Apply appropriate protection controls",
    "choice_d": "Eliminate logging",
    "correct_answer": "C",
    "explanation": "Classification assigns sensitivity levels to data. These levels determine handling, access, and protection requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      111,
      110,
      115,
      121,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 340,
    "question": "Which privacy-enhancing approach keeps data decentralized during model training?",
    "choice_a": "Federated learning",
    "choice_b": "Data masking",
    "choice_c": "Tokenization",
    "choice_d": "Encryption at rest",
    "correct_answer": "A",
    "explanation": "Federated learning trains models locally on distributed data sources. Only model updates are shared, reducing exposure of raw personal data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      207,
      208,
      156
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 341,
    "question": "Transparency in privacy requires that organizations do which of the following?",
    "choice_a": "Inform individuals about data processing",
    "choice_b": "Delete data regularly",
    "choice_c": "Encrypt all systems",
    "choice_d": "Classify hardware assets",
    "correct_answer": "A",
    "explanation": "Transparency ensures individuals are told how their data is used. This supports informed consent and trust.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      34,
      4,
      26,
      28
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 342,
    "question": "Compliance evidence should be which of the following?",
    "choice_a": "Documented and verifiable",
    "choice_b": "Verbal statements",
    "choice_c": "Optional",
    "choice_d": "Stored temporarily",
    "correct_answer": "A",
    "explanation": "Documented evidence demonstrates control operation. It supports audits and regulatory reviews.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      91,
      97,
      96,
      102,
      74
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 343,
    "question": "Attribute-based access control decisions are based on which of the following?",
    "choice_a": "User, resource, and environmental attributes",
    "choice_b": "Static roles only",
    "choice_c": "Encryption keys",
    "choice_d": "Data retention schedules",
    "correct_answer": "A",
    "explanation": "Attribute-based access control (ABAC) evaluates multiple contextual attributes. This enables dynamic, granular access decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      173,
      176,
      174,
      138,
      179
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 344,
    "question": "Data archiving is appropriate when data:",
    "choice_a": "Is actively processed",
    "choice_b": "Must be retained but rarely accessed",
    "choice_c": "Is scheduled for deletion",
    "choice_d": "Is anonymized",
    "correct_answer": "B",
    "explanation": "Archived data is retained for compliance or historical purposes. Access is limited to reduce the risk of unauthorized access.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      128,
      121,
      127,
      125,
      117
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 345,
    "question": "Data subject deletion requests require that organizations do which of the following?",
    "choice_a": "Encrypt data",
    "choice_b": "Transfer data",
    "choice_c": "Remove personal data when applicable",
    "choice_d": "Archive data",
    "correct_answer": "C",
    "explanation": "Deletion rights allow individuals to request the removal of their personal information. Organizations must comply when conditions are met.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      26,
      28,
      34,
      22
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 346,
    "question": "A risk’s likelihood represents which of the following?",
    "choice_a": "Financial impact",
    "choice_b": "Number of controls",
    "choice_c": "Probability of occurrence",
    "choice_d": "Data volume",
    "correct_answer": "C",
    "explanation": "Likelihood measures the chance of a risk event. It is combined with impact to determine severity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      59,
      62,
      71,
      70
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 347,
    "question": "Infrastructure-as-code can introduce privacy risk when which of the following is true?",
    "choice_a": "Secrets are embedded in configuration files",
    "choice_b": "Logging is enabled",
    "choice_c": "Encryption is used",
    "choice_d": "Access controls exist",
    "correct_answer": "A",
    "explanation": "Embedded secrets, such as login credentials or decryption keys, can permit illicit access to personal information. This increases the risk of unauthorized access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      191,
      179,
      192,
      169,
      163
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 348,
    "question": "Aggregated data might still pose a privacy risk when which of the following is true?",
    "choice_a": "Encryption is applied",
    "choice_b": "Retention is limited",
    "choice_c": "Groups are too small",
    "choice_d": "Logging is enabled",
    "correct_answer": "C",
    "explanation": "Small groups, or population subsets, can allow inference about individuals. This increases re-identification risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      122,
      119,
      126,
      121
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 349,
    "question": "Privacy dashboards help management by doing which of the following?",
    "choice_a": "Increasing retention",
    "choice_b": "Eliminating encryption",
    "choice_c": "Providing visibility into program performance",
    "choice_d": "Deleting logs",
    "correct_answer": "C",
    "explanation": "Dashboards summarize metrics. They support decision-making and oversight.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      93,
      102,
      95
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 350,
    "question": "Data retention limits reduce which of the following?",
    "choice_a": "Encryption strength",
    "choice_b": "Network speed",
    "choice_c": "Volume of stored personal data",
    "choice_d": "Vendor risk",
    "correct_answer": "C",
    "explanation": "Limiting data retention reduces exposure. Storing less data reduces the impact of a breach.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      127,
      128,
      121,
      120,
      119
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 351,
    "question": "Multi-factor authentication enhances privacy by doing which of the following?",
    "choice_a": "Increasing data sharing",
    "choice_b": "Strengthening user verification",
    "choice_c": "Removing encryption",
    "choice_d": "Expanding access",
    "correct_answer": "B",
    "explanation": "Multi-factor authentication (MFA) requires multiple authentication types for user logon. This reduces unauthorized access.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      176,
      173,
      175,
      181
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 352,
    "question": "A high-impact, low-likelihood risk should be:",
    "choice_a": "Ignored",
    "choice_b": "Automatically accepted",
    "choice_c": "Deleted from register",
    "choice_d": "Evaluated for mitigation or acceptance",
    "correct_answer": "D",
    "explanation": "High-impact risks require evaluation. Mitigation might still be necessary, based on risk appetite and risk tolerance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      85,
      58,
      82,
      59
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 353,
    "question": "Vendor privacy contracts should define which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Network architecture",
    "choice_c": "Storage limits only",
    "choice_d": "Data protection obligations",
    "correct_answer": "D",
    "explanation": "Contracts enforce privacy requirements by allocating responsibilities among the parties involved.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      50,
      31,
      26,
      32
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 354,
    "question": "Secure coding reduces privacy risk by doing which of the following?",
    "choice_a": "Preventing vulnerabilities that expose data",
    "choice_b": "Increasing data retention",
    "choice_c": "Removing encryption",
    "choice_d": "Eliminating monitoring",
    "correct_answer": "A",
    "explanation": "Secure coding reduces the likelihood of applications containing exploitable flaws. This protects personal data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      159,
      142,
      161,
      144,
      147
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 355,
    "question": "Continuous monitoring helps detect which of the following?",
    "choice_a": "Hardware failures only",
    "choice_b": "Vendor pricing changes",
    "choice_c": "Control effectiveness issues",
    "choice_d": "Storage capacity limits",
    "correct_answer": "C",
    "explanation": "Monitoring identifies deviations in control performance and effectiveness. Corrective action can be taken.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      61,
      66,
      95
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 356,
    "question": "Which activity confirms that personal data has been permanently removed?",
    "choice_a": "Data classification",
    "choice_b": "Data aggregation",
    "choice_c": "Destruction verification",
    "choice_d": "Encryption",
    "correct_answer": "C",
    "explanation": "Destruction verification assures that data was securely removed. It documents completion of disposal procedures and serves as evidence for audits and reviews.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      127,
      128,
      111,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 357,
    "question": "Which technique replaces detailed values with ranges to reduce identifiability?",
    "choice_a": "Tokenization",
    "choice_b": "Generalization",
    "choice_c": "Encryption",
    "choice_d": "Data masking",
    "correct_answer": "B",
    "explanation": "Generalization reduces the specificity of attributes. Broader ranges decrease uniqueness.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      167
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 358,
    "question": "Privacy policies should be:",
    "choice_a": "Approved by management",
    "choice_b": "Optional",
    "choice_c": "Created only by vendors",
    "choice_d": "Informal",
    "correct_answer": "A",
    "explanation": "Management approval establishes authority. Policies guide organizational behavior.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      33,
      17,
      41,
      38,
      1
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 359,
    "question": "When should residual risk be evaluated?",
    "choice_a": "Before risk identification",
    "choice_b": "After data deletion",
    "choice_c": "Before monitoring",
    "choice_d": "After mitigation controls are applied",
    "correct_answer": "D",
    "explanation": "Residual risk remains after controls are implemented. Evaluation determines whether the residual risk should be accepted.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      84,
      65,
      83,
      59,
      82
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 360,
    "question": "Logging supports privacy by doing which of the following?",
    "choice_a": "Increasing retention",
    "choice_b": "Providing traceability of data access",
    "choice_c": "Removing encryption",
    "choice_d": "Aggregating data",
    "correct_answer": "B",
    "explanation": "Data access logs record user actions, including accesses and modifications. This enables accountability.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      144,
      135,
      140,
      173,
      185
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 361,
    "question": "Data discovery tools are primarily used to do which of the following?",
    "choice_a": "Delete data",
    "choice_b": "Locate personal data across systems",
    "choice_c": "Encrypt storage",
    "choice_d": "Increase retention",
    "correct_answer": "B",
    "explanation": "Discovery tools identify data locations. This supports inventory.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      105,
      109,
      103,
      112,
      115
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 362,
    "question": "Privacy incident response plans should include which of the following?",
    "choice_a": "Hardware procurement",
    "choice_b": "Data aggregation",
    "choice_c": "Roles and notification procedures",
    "choice_d": "Encryption keys",
    "correct_answer": "C",
    "explanation": "Plans define responsibilities and steps. This ensures a coordinated and consistent response.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      54,
      33,
      39,
      57,
      38
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 363,
    "question": "Key performance indicators measure which of the following?",
    "choice_a": "Risk likelihood",
    "choice_b": "Program performance",
    "choice_c": "Vendor pricing",
    "choice_d": "Encryption strength",
    "correct_answer": "B",
    "explanation": "Key performance indicators (KPIs) track the achievement of objectives. They support oversight.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      93,
      90,
      66
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 364,
    "question": "Microservices architectures increase privacy risk due to which of the following?",
    "choice_a": "Centralized processing",
    "choice_b": "Reduced scalability",
    "choice_c": "Limited logging",
    "choice_d": "Increased inter-service data flows",
    "correct_answer": "D",
    "explanation": "More services create additional interfaces, increasing the attack surface. This expands exposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      182,
      169,
      159,
      132
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 365,
    "question": "Removing identifiers but keeping location data can still allow which of the following?",
    "choice_a": "Re-identification",
    "choice_b": "Encryption failure",
    "choice_c": "Data minimization",
    "choice_d": "Retention compliance",
    "correct_answer": "A",
    "explanation": "Location patterns can uniquely identify individuals. This increases risk.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      122,
      119,
      121,
      118,
      117
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 366,
    "question": "Risk transfer is commonly achieved through which of the following?",
    "choice_a": "Encryption",
    "choice_b": "Data deletion",
    "choice_c": "Contracts or insurance",
    "choice_d": "Logging",
    "correct_answer": "C",
    "explanation": "Contracts shift responsibility to an external party. Insurance transfers financial risk.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      83,
      65,
      59,
      84
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 367,
    "question": "Secure multi-party computation allows organizations to do which of the following?",
    "choice_a": "Perform joint analysis without exposing data",
    "choice_b": "Share raw data",
    "choice_c": "Delete logs",
    "choice_d": "Tokenize data",
    "correct_answer": "A",
    "explanation": "Computation occurs collaboratively. Raw data remains private.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      207
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 368,
    "question": "Privacy governance aligns privacy activities with which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Vendor pricing",
    "choice_c": "Network architecture",
    "choice_d": "Organizational objectives",
    "correct_answer": "D",
    "explanation": "Governance integrates privacy into organizational strategy. This ensures business alignment.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      7,
      1,
      8,
      16
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 369,
    "question": "Retention schedules define which of the following?",
    "choice_a": "Encryption strength",
    "choice_b": "Data classification",
    "choice_c": "How long data is stored",
    "choice_d": "Vendor oversight",
    "correct_answer": "C",
    "explanation": "Retention schedules set timeframes, supporting storage limitation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      129,
      111,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 370,
    "question": "Which metric best measures breach response effectiveness?",
    "choice_a": "Number of policies",
    "choice_b": "Mean time to containment",
    "choice_c": "Storage utilization",
    "choice_d": "Vendor count",
    "correct_answer": "B",
    "explanation": "Containment time reflects response efficiency. Faster containment reduces impact.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      101,
      94,
      93,
      66,
      91
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 371,
    "question": "How should vendor risk assessments be conducted?",
    "choice_a": "Before onboarding and periodically",
    "choice_b": "Only after contract termination",
    "choice_c": "Never",
    "choice_d": "Only during incidents",
    "correct_answer": "A",
    "explanation": "Ongoing assessments ensure controls remain effective. Risks evolve, as do the effectiveness of vendor controls.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      52,
      51,
      49,
      55,
      12
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 372,
    "question": "APIs should implement authorization to do which of the following?",
    "choice_a": "Increase speed",
    "choice_b": "Control permitted actions",
    "choice_c": "Reduce logging",
    "choice_d": "Increase retention",
    "correct_answer": "B",
    "explanation": "Authorization limits operations. This prevents unauthorized data access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      176,
      161,
      174,
      173,
      179
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 373,
    "question": "Risk avoidance involves which of the following?",
    "choice_a": "Eliminating risky processing",
    "choice_b": "Accepting risk",
    "choice_c": "Encrypting data",
    "choice_d": "Logging access",
    "correct_answer": "A",
    "explanation": "Avoidance removes the risk source through discontinued processing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      59
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 374,
    "question": "Data disposal policies help prevent which of the following?",
    "choice_a": "Encryption errors",
    "choice_b": "Unauthorized data recovery",
    "choice_c": "Data classification",
    "choice_d": "Vendor risk",
    "correct_answer": "B",
    "explanation": "Secure disposal removes recoverable data. This protects confidentiality.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      129,
      111,
      127,
      121,
      128
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 375,
    "question": "Tokenization protects personal data by doing which of the following?",
    "choice_a": "Deleting data",
    "choice_b": "Aggregating data",
    "choice_c": "Masking ranges",
    "choice_d": "Replacing values with tokens",
    "correct_answer": "D",
    "explanation": "Tokens substitute sensitive, recoverable values. The mapping of sensitive values and tokens is stored separately.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      206,
      207,
      187
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 376,
    "question": "Privacy metrics should do which of the following?",
    "choice_a": "Align with program objectives",
    "choice_b": "Focus only on technical data",
    "choice_c": "Ignore risk levels",
    "choice_d": "Exclude governance measures",
    "correct_answer": "A",
    "explanation": "Alignment ensures metrics are meaningful. They support visibility into control effectiveness, facilitating continual improvement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      90,
      102,
      59
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 377,
    "question": "Least privilege combined with separation of duties primarily reduces which of the following?",
    "choice_a": "Storage costs",
    "choice_b": "Encryption complexity",
    "choice_c": "Vendor dependencies",
    "choice_d": "Insider misuse risk",
    "correct_answer": "D",
    "explanation": "Limited access and divided responsibilities reduce abuse. This strengthens controls.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      174,
      179,
      175,
      181,
      180
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 378,
    "question": "Data aggregation reduces privacy risk by doing which of the following?",
    "choice_a": "Increasing detail",
    "choice_b": "Extending retention",
    "choice_c": "Removing individual-level data",
    "choice_d": "Removing encryption",
    "correct_answer": "C",
    "explanation": "Aggregated data obscures individuals in datasets, lowering re-identification risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      122,
      121,
      119,
      126
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 379,
    "question": "Data portability requests require data to be:",
    "choice_a": "Provided in structured format",
    "choice_b": "Deleted",
    "choice_c": "Archived",
    "choice_d": "Tokenized",
    "correct_answer": "A",
    "explanation": "Portability requires usable formats, so that individuals can reuse data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      56,
      34,
      22,
      28
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 380,
    "question": "Impact refers to which of the following?",
    "choice_a": "Probability of occurrence",
    "choice_b": "Severity of consequences",
    "choice_c": "Number of controls",
    "choice_d": "Data volume",
    "correct_answer": "B",
    "explanation": "Impact measures the magnitude of harm. Impact is combined with the likelihood to identify the risk level.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      69,
      59,
      64,
      70,
      82
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 381,
    "question": "Containers can create privacy risk when which of the following is true?",
    "choice_a": "Logging is enabled",
    "choice_b": "Encryption is used",
    "choice_c": "Sensitive data is stored in images",
    "choice_d": "Access is restricted",
    "correct_answer": "C",
    "explanation": "Embedded data, such as API keys, in container images can be exposed. This increases risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      207,
      140,
      135,
      191
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 382,
    "question": "Unique combinations of attributes create which of the following?",
    "choice_a": "Data minimization",
    "choice_b": "Retention violation",
    "choice_c": "Re-identification risk",
    "choice_d": "Encryption failure",
    "correct_answer": "C",
    "explanation": "Unique attribute sets identify individuals. This increases linkage risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      119,
      121,
      116,
      120
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 383,
    "question": "Monitoring privacy controls helps which of the following?",
    "choice_a": "Increase retention",
    "choice_b": "Detect control failures",
    "choice_c": "Remove encryption",
    "choice_d": "Delete logs",
    "correct_answer": "B",
    "explanation": "Monitoring identifies deviations in control performance. Corrective action is taken to reduce risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      92,
      94,
      61,
      66,
      95
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 384,
    "question": "Differential privacy protects individuals by doing which of the following?",
    "choice_a": "Encrypting data",
    "choice_b": "Adding statistical noise",
    "choice_c": "Deleting records",
    "choice_d": "Tokenizing data",
    "correct_answer": "B",
    "explanation": "The addition of statistical noise prevents inference of individuals. Aggregate value remains.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      208,
      206
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 385,
    "question": "Privacy governance committees support which of the following?",
    "choice_a": "Hardware lifecycle",
    "choice_b": "Encryption strength",
    "choice_c": "Data aggregation",
    "choice_d": "Oversight and decision-making",
    "correct_answer": "D",
    "explanation": "Committees coordinate governance, thereby providing accountability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      1,
      3,
      38,
      5
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 386,
    "question": "Archiving data requires which of the following?",
    "choice_a": "Secure long-term storage",
    "choice_b": "Immediate deletion",
    "choice_c": "Public access",
    "choice_d": "No controls",
    "correct_answer": "A",
    "explanation": "Archived data is retained securely. Access is restricted.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      125,
      127,
      111,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 387,
    "question": "When does encryption at rest protect data?",
    "choice_a": "During transmission",
    "choice_b": "When stored on media",
    "choice_c": "During deletion",
    "choice_d": "During classification",
    "correct_answer": "B",
    "explanation": "Encryption at rest secures stored data. Unauthorized access is prevented.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      192,
      191,
      206,
      207
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 388,
    "question": "A risk scoring matrix combines which of the following?",
    "choice_a": "Likelihood and impact",
    "choice_b": "Vendor cost and duration",
    "choice_c": "Storage and bandwidth",
    "choice_d": "Logging and encryption",
    "correct_answer": "A",
    "explanation": "Combined likelihood and impact values determine risk severity. This supports prioritization of risk treatment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      70,
      82,
      59,
      64
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 389,
    "question": "Data lineage helps organizations do which of the following?",
    "choice_a": "Delete data",
    "choice_b": "Increase retention",
    "choice_c": "Understand data flows",
    "choice_d": "Remove encryption",
    "correct_answer": "C",
    "explanation": "Lineage documents movement and transformation within an organization, improving visibility and transparency.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      106,
      107,
      108,
      109,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 390,
    "question": "Incident notification decisions depend on which of the following?",
    "choice_a": "Storage capacity",
    "choice_b": "Network bandwidth",
    "choice_c": "Regulatory requirements",
    "choice_d": "Vendor pricing",
    "correct_answer": "C",
    "explanation": "Privacy and security laws define notification thresholds. Organizations must comply.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      57,
      26,
      27,
      54,
      25
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 391,
    "question": "Secure coding practices aim to do which of the following?",
    "choice_a": "Increase data collection",
    "choice_b": "Remove logging",
    "choice_c": "Increase retention",
    "choice_d": "Prevent vulnerabilities",
    "correct_answer": "D",
    "explanation": "Secure coding reduces flaws that, if exploited, could expose personal data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      159,
      142,
      147,
      144,
      161
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 392,
    "question": "Data quality controls help protect privacy by ensuring:",
    "choice_a": "Maximum retention",
    "choice_b": "Accurate personal data processing",
    "choice_c": "Increased data sharing",
    "choice_d": "Reduced encryption",
    "correct_answer": "B",
    "explanation": "Accurate data prevents incorrect decisions about individuals. This supports fairness and reliability in processing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      103,
      104,
      110,
      117
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 393,
    "question": "Which technique removes identifiers but retains analytical usefulness with reduced risk?",
    "choice_a": "Pseudonymization",
    "choice_b": "Encryption",
    "choice_c": "Deletion",
    "choice_d": "Aggregation",
    "correct_answer": "A",
    "explanation": "Pseudonymization replaces identifiers with substitutes. Re-identification requires separate mapping.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      208
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 394,
    "question": "Privacy governance establishes which of the following?",
    "choice_a": "Hardware requirements",
    "choice_b": "Accountability structure",
    "choice_c": "Encryption standards only",
    "choice_d": "Data retention limits",
    "correct_answer": "B",
    "explanation": "Governance defines oversight roles. This supports accountability.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      3,
      38,
      7,
      1,
      33
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 395,
    "question": "When mitigation reduces likelihood but not impact, residual risk reflects which of the following?",
    "choice_a": "Remaining exposure after controls",
    "choice_b": "Eliminated risk",
    "choice_c": "Transferred risk",
    "choice_d": "Avoided risk",
    "correct_answer": "A",
    "explanation": "Residual risk is the remaining risk after controls. It must be evaluated for acceptance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      65,
      83,
      59,
      85
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 396,
    "question": "Monitoring user activity supports privacy by doing which of the following?",
    "choice_a": "Increasing retention",
    "choice_b": "Detecting unauthorized access",
    "choice_c": "Removing encryption",
    "choice_d": "Aggregating data",
    "correct_answer": "B",
    "explanation": "Monitoring identifies suspicious behavior. This supports incident response.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      181,
      193,
      202,
      194,
      173
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 397,
    "question": "Data destruction policies should specify which of the following?",
    "choice_a": "Vendor pricing",
    "choice_b": "Network topology",
    "choice_c": "Approved disposal methods",
    "choice_d": "Encryption algorithms",
    "correct_answer": "C",
    "explanation": "Policies define secure, risk-based disposal techniques. This prevents data recovery.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      129,
      111,
      127,
      103,
      128
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 398,
    "question": "Data subject portability allows individuals to do which of the following?",
    "choice_a": "Delete data",
    "choice_b": "Encrypt data",
    "choice_c": "Archive data",
    "choice_d": "Receive data in reusable format",
    "correct_answer": "D",
    "explanation": "Portability supports the reuse of personal data. Formats must be structured.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      28,
      29
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 399,
    "question": "Key risk indicators measure which of the following?",
    "choice_a": "Program performance",
    "choice_b": "Risk exposure trends",
    "choice_c": "Vendor pricing",
    "choice_d": "Encryption strength",
    "correct_answer": "B",
    "explanation": "Key risk indicators (KRIs) track risk levels. They support proactive management.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      94,
      92,
      66,
      59,
      60
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 400,
    "question": "Infrastructure-as-code increases privacy risk when which of the following is true?",
    "choice_a": "Logging is enabled",
    "choice_b": "Encryption is applied",
    "choice_c": "Access controls exist",
    "choice_d": "Sensitive values are hardcoded",
    "correct_answer": "D",
    "explanation": "Hardcoded secrets, such as API keys and service account credentials, expose credentials. This increases the risk of unauthorized access.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      180,
      135,
      173,
      140,
      144
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 401,
    "question": "Combining anonymized data with public records can allow which of the following?",
    "choice_a": "Encryption failure",
    "choice_b": "Data deletion",
    "choice_c": "Re-identification",
    "choice_d": "Data retention violation",
    "correct_answer": "C",
    "explanation": "External data can be used to link records. This increases identification risk.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      122,
      119,
      126,
      121,
      118
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 402,
    "question": "Risk avoidance is best described as which of the following?",
    "choice_a": "Accepting residual risk",
    "choice_b": "Transferring risk",
    "choice_c": "Monitoring risk",
    "choice_d": "Eliminating risky processing",
    "correct_answer": "D",
    "explanation": "In risk avoidance, the activity introducing the risk is discontinued, eliminating the risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      83,
      59,
      82,
      85
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 403,
    "question": "Privacy governance committees ensure which of the following?",
    "choice_a": "Hardware lifecycle management",
    "choice_b": "Encryption key rotation",
    "choice_c": "Vendor pricing control",
    "choice_d": "Oversight of privacy decisions",
    "correct_answer": "D",
    "explanation": "Committees coordinate program oversight. They support accountability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      1,
      38,
      5,
      3
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 404,
    "question": "Secure wiping involves which of the following?",
    "choice_a": "Deleting files",
    "choice_b": "Archiving data",
    "choice_c": "Tokenizing values",
    "choice_d": "Overwriting storage media",
    "correct_answer": "D",
    "explanation": "Overwriting ensures destruction by preventing the recovery of sensitive data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      127,
      111,
      121,
      128
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 405,
    "question": "Least privilege reduces privacy risk by doing which of the following?",
    "choice_a": "Increasing access",
    "choice_b": "Increasing retention",
    "choice_c": "Removing logging",
    "choice_d": "Limiting permissions",
    "correct_answer": "D",
    "explanation": "Restricted access permissions reduce exposure. Only necessary access is granted.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      174,
      173,
      176,
      179,
      180
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 406,
    "question": "Which metric best indicates privacy awareness effectiveness?",
    "choice_a": "Decrease in user-related incidents",
    "choice_b": "Number of policies",
    "choice_c": "Storage utilization",
    "choice_d": "Vendor count",
    "correct_answer": "A",
    "explanation": "Fewer incidents indicate improved awareness. Training effectiveness improves behavior.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      76,
      92,
      94,
      78,
      101
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 407,
    "question": "Vendor contracts should address which of the following?",
    "choice_a": "Data protection requirements",
    "choice_b": "Hardware lifecycle",
    "choice_c": "Network speed",
    "choice_d": "Storage capacity",
    "correct_answer": "A",
    "explanation": "Contracts with third parties must define privacy obligations. Vendors must comply with all provisions.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      51,
      50,
      49,
      31,
      52
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 408,
    "question": "When does the secure development lifecycle integrate privacy?",
    "choice_a": "After deployment",
    "choice_b": "Throughout development",
    "choice_c": "Only during audits",
    "choice_d": "Only during incidents",
    "correct_answer": "B",
    "explanation": "Requirements are incorporated early and enforced throughout development. This reduces design flaws.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      144,
      142,
      146,
      145,
      148
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 409,
    "question": "Risk scoring evaluates which of the following?",
    "choice_a": "Storage capacity",
    "choice_b": "Vendor pricing",
    "choice_c": "Encryption strength",
    "choice_d": "Likelihood and impact",
    "correct_answer": "D",
    "explanation": "The combined factors of likelihood and impact determine risk severity. This supports prioritization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      70,
      59,
      82,
      62
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 410,
    "question": "Federated learning enhances privacy because:",
    "choice_a": "Data remains local during training",
    "choice_b": "Data is centralized",
    "choice_c": "Logs are deleted",
    "choice_d": "Encryption is removed",
    "correct_answer": "A",
    "explanation": "Training occurs locally. Raw data is not shared.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      208,
      206
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 411,
    "question": "Accountability requires which of the following?",
    "choice_a": "Removing documentation",
    "choice_b": "Increasing retention",
    "choice_c": "Disabling monitoring",
    "choice_d": "Demonstrating compliance",
    "correct_answer": "D",
    "explanation": "Documentation proves compliance, supporting accountability oversight.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      31,
      3,
      5,
      37,
      33
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 412,
    "question": "Separation of duties primarily reduces which of the following?",
    "choice_a": "Storage costs",
    "choice_b": "Insider misuse risk",
    "choice_c": "Encryption complexity",
    "choice_d": "Vendor dependencies",
    "correct_answer": "B",
    "explanation": "Duties are divided among individual staff. No single user has excessive control that could lead to misuse.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      174,
      179,
      181,
      180,
      169
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 413,
    "question": "Data subject rectification requests allow individuals to do which of the following?",
    "choice_a": "Delete data",
    "choice_b": "Transfer ownership",
    "choice_c": "Correct inaccurate data",
    "choice_d": "Archive data",
    "correct_answer": "C",
    "explanation": "Rectification improves accuracy. Incorrect data is corrected.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      56,
      26,
      55,
      3,
      22
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 414,
    "question": "Likelihood refers to which of the following?",
    "choice_a": "Severity",
    "choice_b": "Probability",
    "choice_c": "Data volume",
    "choice_d": "Number of controls",
    "correct_answer": "B",
    "explanation": "Likelihood measures the chance of occurrence. It is combined with impact to calculate risk.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      69,
      59,
      62,
      70,
      71
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 415,
    "question": "Container images create privacy risk when which of the following is true?",
    "choice_a": "Logging is enabled",
    "choice_b": "Encryption is used",
    "choice_c": "Access controls exist",
    "choice_d": "Sensitive data is embedded",
    "correct_answer": "D",
    "explanation": "Embedded data, such as API keys, can be exposed, increasing risk.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      161,
      159,
      206,
      187,
      169
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 416,
    "question": "Unique attribute combinations create which of the following?",
    "choice_a": "Data minimization",
    "choice_b": "Re-identification risk",
    "choice_c": "Retention violation",
    "choice_d": "Encryption failure",
    "correct_answer": "B",
    "explanation": "Unique sets can permit the identification of individuals. This increases risk.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      119,
      122,
      118,
      116,
      121
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 417,
    "question": "Privacy governance alignment ensures which of the following?",
    "choice_a": "Integration with enterprise objectives",
    "choice_b": "Hardware lifecycle control",
    "choice_c": "Encryption strength",
    "choice_d": "Vendor pricing",
    "correct_answer": "A",
    "explanation": "Alignment supports strategic objectives. Governance is integrated.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      6,
      1,
      8,
      7,
      16
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 418,
    "question": "Data archiving requires which of the following?",
    "choice_a": "Immediate deletion",
    "choice_b": "Controlled long-term storage",
    "choice_c": "Public access",
    "choice_d": "No monitoring",
    "correct_answer": "B",
    "explanation": "Archived data is secured. Access is limited to fewer individuals, processes, and systems.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      121,
      128,
      111,
      103
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 419,
    "question": "What does encryption in transit protect?",
    "choice_a": "Stored data",
    "choice_b": "Data moving between systems",
    "choice_c": "Archived data",
    "choice_d": "Classified data",
    "correct_answer": "B",
    "explanation": "Encryption secures communications. Interception is prevented.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      187,
      140,
      185,
      184,
      203
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 420,
    "question": "Residual risk acceptance requires which of the following?",
    "choice_a": "Ignoring risk",
    "choice_b": "Formal management approval",
    "choice_c": "Data deletion",
    "choice_d": "Encryption removal",
    "correct_answer": "B",
    "explanation": "Risk acceptance must be documented. Management must approve all risk treatment decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      65,
      84,
      82,
      59
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 421,
    "question": "Data lineage supports which of the following?",
    "choice_a": "Deletion",
    "choice_b": "Increasing retention",
    "choice_c": "Removing encryption",
    "choice_d": "Understanding data flow",
    "correct_answer": "D",
    "explanation": "Lineage documents transformations, improving transparency.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      106,
      107,
      109,
      108,
      124
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 422,
    "question": "Breach notification timing depends on which of the following?",
    "choice_a": "Storage capacity",
    "choice_b": "Regulatory requirements",
    "choice_c": "Vendor pricing",
    "choice_d": "Encryption strength",
    "correct_answer": "B",
    "explanation": "Laws define timelines and other terms concerning breaches. Organizations must comply.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      57,
      27,
      26,
      53,
      30
    ],
    "source": "363803_Practice_Exam 2"
  },
  {
    "id": 423,
    "question": "Secure coding aims to do which of the following?",
    "choice_a": "Increase retention",
    "choice_b": "Remove encryption",
    "choice_c": "Disable logging",
    "choice_d": "Prevent vulnerabilities",
    "correct_answer": "D",
    "explanation": "Secure coding reduces exploitable flaws. This protects data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      159,
      142,
      144,
      161,
      147
    ],
    "source": "363803_Practice_Exam 2"
  }
];
